webpackJsonp([13],{

/***/ 386:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Result_vue__ = __webpack_require__(699);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_440dc520_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Result_vue__ = __webpack_require__(831);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Result_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_440dc520_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Result_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(469));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(468));

var _alphaNum = _interopRequireDefault(__webpack_require__(471));

var _numeric = _interopRequireDefault(__webpack_require__(472));

var _between = _interopRequireDefault(__webpack_require__(473));

var _email = _interopRequireDefault(__webpack_require__(474));

var _ipAddress = _interopRequireDefault(__webpack_require__(475));

var _macAddress = _interopRequireDefault(__webpack_require__(476));

var _maxLength = _interopRequireDefault(__webpack_require__(477));

var _minLength = _interopRequireDefault(__webpack_require__(478));

var _required = _interopRequireDefault(__webpack_require__(479));

var _requiredIf = _interopRequireDefault(__webpack_require__(480));

var _requiredUnless = _interopRequireDefault(__webpack_require__(481));

var _sameAs = _interopRequireDefault(__webpack_require__(482));

var _url = _interopRequireDefault(__webpack_require__(483));

var _or = _interopRequireDefault(__webpack_require__(484));

var _and = _interopRequireDefault(__webpack_require__(485));

var _not = _interopRequireDefault(__webpack_require__(486));

var _minValue = _interopRequireDefault(__webpack_require__(487));

var _maxValue = _interopRequireDefault(__webpack_require__(488));

var _integer = _interopRequireDefault(__webpack_require__(489));

var _decimal = _interopRequireDefault(__webpack_require__(490));

var helpers = _interopRequireWildcard(__webpack_require__(465));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","BRAND_NAME":"Trransfer","VUE_APP_GOOGLE_MAPS_KEY":"AIzaSyDwoOCBqFXIhPMWg922paZIpeVZkudwH6I","VUE_APP_BASE_API":"https://prod-gateway-opsicar.idteknologia.net","VUE_APP_AUTH_HOST":"https://authservice.trransfer.com","VUE_APP_CDN":"https://maverick-global-assets-cp52hf.s3.ap-southeast-1.amazonaws.com","VUE_APP_GOOGLE_TAG_ID":"UA-171512499-1","VUE_APP_SUPPORT_WIDGET_ID":"51000003059","VUE_APP_SUPPORT_WIDGET_SOURCE":"https://aus-widget.freshworks.com/widgets/51000003059.js"}).BUILD === 'web' ? __webpack_require__(470).withParams : __webpack_require__(235).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'required'
}, function (value) {
  if (typeof value === 'string') {
    return (0, _common.req)(value.trim());
  }

  return (0, _common.req)(value);
});

exports.default = _default;

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('integer', /(^[0-9]*$)|(^-[0-9]+$)/);

exports.default = _default;

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 501:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["id", "header", "content", "closeIcon", "cancelLabel", "submitLabel", "color", "icon", "subContent", "modalSize"],
  computed: {
    hasCloseIcon: function hasCloseIcon() {
      return this.closeIcon && this.closeIcon === true ? true : false;
    },
    hasCancel: function hasCancel() {
      return this.cancelLabel && this.cancelLabel !== "";
    },
    hasSubmit: function hasSubmit() {
      return this.submitLabel && this.submitLabel !== "";
    },
    getId: function getId() {
      return this.id && this.id !== "" ? this.id : "confirmmodal";
    },
    getColor: function getColor() {
      return this.color && this.color !== "" ? this.color : "confirm-icon";
    },
    getIcon: function getIcon() {
      return this.icon && this.icon !== "" ? this.icon : "ic-check";
    }
  },
  methods: {
    closeModal: function closeModal() {
      $("#" + this.getId).modal("hide");
    },
    cancel: function cancel() {
      this.$emit("onCancel");
    },
    submit: function submit() {
      $("#" + this.getId).modal("hide");
      this.$emit("submit");
    }
  }
});

/***/ }),

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/companies';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list' + filter).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllActive: function getAllActive() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/active').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  create: function create(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  update: function update(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  changeStatus: function changeStatus(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/status', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  delete: function _delete(id) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + '/' + id).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
});

/***/ }),

/***/ 509:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmModal_vue__ = __webpack_require__(501);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6af674af_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmModal_vue__ = __webpack_require__(518);
function injectStyle (ssrContext) {
  __webpack_require__(516)
}
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6af674af"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6af674af_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(517);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(384)("5636d7fe", content, true, {});

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(383)(true);
// imports


// module
exports.push([module.i, ".note-content[data-v-6af674af]{font-size:13px;color:#999}.modal-header-confirm[data-v-6af674af]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding:15px}", "", {"version":3,"sources":["/app/src/components/shared/ConfirmModal.vue"],"names":[],"mappings":"AACA,+BACE,eAAgB,AAChB,UAAY,CACb,AACD,uCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,kBAAmB,AACf,yBAA0B,AAClC,YAAc,CACf","file":"ConfirmModal.vue","sourcesContent":["\n.note-content[data-v-6af674af] {\n  font-size: 13px;\n  color: #999;\n}\n.modal-header-confirm[data-v-6af674af] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding: 15px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"role":"dialog","id":_vm.getId}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalSize === 'modal-sm' ? 'modal-sm' : 'modal-xs'},[_c('div',{staticClass:"modal-content"},[(_vm.hasCloseIcon)?_c('div',{staticClass:"modal-header-confirm"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.closeModal()}}},[_c('i',{staticClass:"ic-close"})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-body modal-confirmation"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-wrapper"},[(_vm.icon === 'ic-warning')?[_c('svg',{staticClass:"warning-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 20 20"}},[_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"M8.686 2.852L2.127 14.777A1.5 1.5 0 0 0 3.441 17H16.56a1.5 1.5 0 0 0 1.314-2.223L11.314 2.852a1.5 1.5 0 0 0-2.628 0zM10 6.75a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75zm.75 7a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0z","fill":"currentColor"}})])])]:[_c('div',{class:_vm.getColor},[_c('i',{class:_vm.getIcon})])],_vm._v(" "),_c('header',[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._v(" "),(_vm.subContent)?[_c('div',{staticClass:"note-content",domProps:{"innerHTML":_vm._s(_vm.subContent)}})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[(_vm.hasCancel)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.cancel}},[_vm._v("\n                  "+_vm._s(_vm.cancelLabel)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.hasSubmit)?_c('button',{staticClass:"btn btn-primary text-cap",attrs:{"type":"submit"},on:{"click":_vm.submit}},[_vm._v("\n                  "+_vm._s(_vm.submitLabel)+"\n                ")]):_vm._e()])],2)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export arrayContainElement */
/* unused harmony export allowedPermission */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return allowToViewCustomerNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return allowToViewAdminNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return allowToAddEditAdminNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return allowRepricingAirportTransfer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return allowRepricingHourly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return companySelectorAirportTransfer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return companySelectorHourly; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_constants__ = __webpack_require__(237);


var arrayContainElement = function arrayContainElement(arrayValue) {
  return arrayValue && arrayValue !== null;
};

var allowedPermission = function allowedPermission(currentUserPermission, permissionGroup, permission) {
  return arrayContainElement(currentUserPermission) && currentUserPermission[permissionGroup].includes(permission);
};

var allowToViewCustomerNotes = function allowToViewCustomerNotes(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].AirportTransferReservation, "ViewCustomerNote");
};

var allowToViewAdminNotes = function allowToViewAdminNotes(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].AirportTransferReservation, "ViewAdminNote");
};

var allowToAddEditAdminNotes = function allowToAddEditAdminNotes(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].AirportTransferReservation, "AddEditAdminNote");
};

var allowRepricingAirportTransfer = function allowRepricingAirportTransfer(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].AirportTransferReservation, "Reprice") && allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].AirportTransferReservation, "ViewRepriceHistory");
};

var allowRepricingHourly = function allowRepricingHourly(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].HourlyReservation, "Reprice") && allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].HourlyReservation, "ViewRepriceHistory");
};

var companySelectorAirportTransfer = function companySelectorAirportTransfer(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].InquiryAvailability, "CompanySelector");
};

var companySelectorHourly = function companySelectorHourly(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].InstantAvailability, "CompanySelector");
};

/***/ }),

/***/ 533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


var _autocomplete;
var _sessionToken;
var _placesService;

var MaverickAutoComplete = function () {
  function MaverickAutoComplete() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MaverickAutoComplete);

    _autocomplete = new google.maps.places.AutocompleteService();
    _sessionToken = new google.maps.places.AutocompleteSessionToken();
    _placesService = new google.maps.places.PlacesService(document.createElement("div"));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(MaverickAutoComplete, [{
    key: 'getPredictions',
    value: function getPredictions(keyword, callback, options) {
      if (!_sessionToken) {
        this.refreshToken();
      }
      // only trigger google service when char is more than equal to 3
      if (keyword.length >= 3) {
        var request = {
          input: keyword,
          sessionToken: _sessionToken
        };
        if (options && options.country) {
          request.componentRestrictions = {
            'country': options.country
          };
        }
        _autocomplete.getPlacePredictions(request, function (predictions, status) {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            callback(predictions);
          }
        });
      }
    }
  }, {
    key: 'getPlace',
    value: function getPlace(prediction, callback) {
      var _this = this;

      var request = {
        placeId: prediction.place_id,
        fields: ['name', 'formatted_address', 'geometry', 'address_component'],
        sessionToken: _sessionToken
      };
      _placesService.getDetails(request, function (place, status) {
        // renew session token everytime place details has been requested
        _this.refreshToken();

        if (status === google.maps.places.PlacesServiceStatus.OK) {
          var country = '';
          for (var i = place.address_components.length - 1; i >= 0; i--) {
            if (place.address_components[i].types.find(function (x) {
              return x.toLowerCase() === 'country';
            }) !== undefined) {
              country = place.address_components[i].short_name;
              break;
            }
          }
          callback({
            latitude: place.geometry.location.lat(),
            longitude: place.geometry.location.lng(),
            name: place.name,
            address: place.name + ', ' + place.formatted_address,
            country: country
          });
        }
      });
    }
  }, {
    key: 'refreshToken',
    value: function refreshToken() {
      _sessionToken = new google.maps.places.AutocompleteSessionToken();
    }
  }]);

  return MaverickAutoComplete;
}();

/* harmony default export */ __webpack_exports__["a"] = (MaverickAutoComplete);

/***/ }),

/***/ 589:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_master_airportService_js__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_userHelper_js__ = __webpack_require__(531);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: { type: String, required: true },
    companies: { type: Array },
    services: { type: Object }
  },
  data: function data() {
    return {
      isSubmitted: false,
      airports: [],
      popularDestinations: [],
      isModified: false,
      isDepartureFromAirport: false,
      isAvoidCrossCity: false,
      minimumPickUpDate: null,
      maximumPickUpDate: null,
      refreshSessionInterval: null,
      searchClone: {
        pickUpLocation: {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
          isAirportZone: false
        },
        dropOffLocation: {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
          isAirportZone: false
        }
      },
      searchRequest: {
        pickUpLocation: {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
          isAirportZone: false
        },
        dropOffLocation: {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
          isAirportZone: false
        },
        pickUpDate: null,
        pickUpTime: null,
        mode: "",
        company: null
      },
      permissions: null,
      companyOption: [],
      modifySearch: false
    };
  },
  validations: function validations() {
    return {
      searchRequest: {
        pickUpLocation: {
          name: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] }
        },
        dropOffLocation: {
          name: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] }
        },
        pickUpDate: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
        pickUpTime: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] }
      }
    };
  },

  computed: {
    hasCompanySelector: function hasCompanySelector() {
      if (this.permissions) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__helpers_userHelper_js__["f" /* companySelectorAirportTransfer */])(this.permissions);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_5__helpers_userHelper_js__["f" /* companySelectorAirportTransfer */])(this.services);
    },
    departureAirports: function departureAirports() {
      if (this.searchRequest && this.searchRequest.pickUpLocation && this.searchRequest.pickUpLocation.name) {
        var pattern = new RegExp(this.searchRequest.pickUpLocation.name.toLowerCase(), "i");
        return this.airports.filter(function (airport) {
          return pattern.test(airport.air_code) || pattern.test(airport.air_name) || pattern.test(airport.ct_code) || pattern.test(airport.ct_name) || pattern.test(airport.cn_code) || pattern.test(airport.cn_name);
        });
      }
      return this.airports;
    },
    arrivalAirports: function arrivalAirports() {
      if (this.searchRequest && this.searchRequest.dropOffLocation && this.searchRequest.dropOffLocation.name) {
        var pattern = new RegExp(this.searchRequest.dropOffLocation.name.toLowerCase(), "i");
        return this.airports.filter(function (airport) {
          return pattern.test(airport.air_code) || pattern.test(airport.air_name) || pattern.test(airport.ct_code) || pattern.test(airport.ct_name) || pattern.test(airport.cn_code) || pattern.test(airport.cn_name);
        });
      }
      return this.airports;
    }
  },
  mounted: function mounted() {
    document.addEventListener("click", function (event) {
      var div = document.querySelector("#airportTransfer");
      if (div) {
        div.querySelectorAll(".list-autoComplete, .popularCity, .geolocationAirport").forEach(function (element) {
          return element.classList.remove("isOpen");
        });
      }
      if ($("#airportTransfer .searchBox__input-from, #airportTransfer .searchBox__input-to").is(event.target)) {
        var searchResult = $(event.target.parentElement).find(".list-autoComplete");
        var popularCity = $(event.target.parentElement).find(".popularCity");
        var geolocationAirport = $(event.target.parentElement).find(".geolocationAirport");

        if (searchResult.length > 0 && searchResult[0].getElementsByTagName("li").length > 0) {
          searchResult[0].classList.add("isOpen");
        } else if (popularCity.length > 0 && popularCity[0].getElementsByTagName("li").length > 0) {
          popularCity[0].classList.add("isOpen");
        } else if (geolocationAirport.length > 0 && geolocationAirport[0].getElementsByTagName("li").length > 0) {
          geolocationAirport[0].classList.add("isOpen");
        }
      }
    });

    document.addEventListener("keydown", this.handleEnter);
    $(".help-tip").popover({ trigger: "hover" });
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var publicSettings, profile, userType, minDays, maxMonths, self, pickUpLocations, dropOffLocations;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch("setting/getAllPublic");

            case 2:
              publicSettings = _context.sent;
              _context.next = 5;
              return _this.$store.dispatch("user/getProfile");

            case 5:
              profile = _context.sent;
              userType = profile.userType;
              minDays = userType === "TenantUser" ? 0 : parseInt(_this.$helper.extractSetting(publicSettings, "SearchMinDay", 0));
              maxMonths = userType === "TenantUser" ? 10000 : parseInt(_this.$helper.extractSetting(publicSettings, "BookingLimit", 0));


              _this.isAvoidCrossCity = _this.$helper.extractSetting(publicSettings, "AvoidCrossCity", "false") === "true";

              _context.next = 12;
              return __WEBPACK_IMPORTED_MODULE_3__services_master_airportService_js__["a" /* default */].getAll();

            case 12:
              _this.airports = _context.sent;
              self = _this;
              // subscribe messages

              _this.$eventBus.$on("navigateToAirportTransfer", function () {
                return self.$parent.autocomplete.refreshToken();
              });
              _this.$eventBus.$on("bindAirportTransfer", _this.bindModelFromModifySearch);

              _this.refreshSessionInterval = setInterval(function () {
                self.$parent.autocomplete.refreshToken();
              }, 60000);

              pickUpLocations = _this.$helper.extractSetting(publicSettings, "AirportPickup", "-6.1275282|106.6537058|Soekarno-Hatta International Airport|Soekarno-Hatta International Airport, Tangerang City, Banten, Indonesia|ID|CGK").split("|");


              _this.searchRequest.pickUpLocation = {
                latitude: parseFloat(pickUpLocations[0]),
                longitude: parseFloat(pickUpLocations[1]),
                name: pickUpLocations[2],
                address: pickUpLocations[3],
                country: pickUpLocations[4]
              };

              _this.searchClone.pickUpLocation = {
                latitude: parseFloat(pickUpLocations[0]),
                longitude: parseFloat(pickUpLocations[1]),
                name: pickUpLocations[2],
                address: pickUpLocations[3],
                country: pickUpLocations[4]
              };

              if (pickUpLocations.length === 6) {
                _this.isDepartureFromAirport = true;
                _this.searchRequest.pickUpLocation.code = pickUpLocations[5];
                _this.searchRequest.pickUpLocation.isAirportZone = true;

                _this.searchClone.pickUpLocation.code = pickUpLocations[5];
                _this.searchClone.pickUpLocation.isAirportZone = true;
              }

              dropOffLocations = _this.$helper.extractSetting(publicSettings, "AirportDropoff", "-6.1767112|106.8306527|Gambir Station|Gambir Station, Jalan Medan Merdeka Timur, Gambir, Central Jakarta City, Jakarta, Indonesia|ID").split("|");


              _this.searchRequest.dropOffLocation = {
                latitude: parseFloat(dropOffLocations[0]),
                longitude: parseFloat(dropOffLocations[1]),
                name: dropOffLocations[2],
                address: dropOffLocations[3],
                country: dropOffLocations[4]
              };

              _this.searchClone.dropOffLocation = {
                latitude: parseFloat(dropOffLocations[0]),
                longitude: parseFloat(dropOffLocations[1]),
                name: dropOffLocations[2],
                address: dropOffLocations[3],
                country: dropOffLocations[4]
              };

              if (dropOffLocations.length === 6) {
                _this.isDepartureFromAirport = false;
                _this.searchRequest.dropOffLocation.code = dropOffLocations[5];
                _this.searchRequest.dropOffLocation.isAirportZone = true;

                _this.searchClone.dropOffLocation.code = dropOffLocations[5];
                _this.searchClone.dropOffLocation.isAirportZone = true;
              }

              _this.searchRequest.pickUpDate = _this.$helper.toStringDate(_this.$helper.addDays(minDays));

              _this.searchRequest.pickUpTime = "10:00";

              _this.minimumPickUpDate = _this.$helper.toStringDate(_this.$helper.addDays(minDays));

              _this.maximumPickUpDate = _this.$helper.toStringDate(_this.$helper.addMonths(maxMonths));

              _this.popularDestinations = [
                // {
                //   name: "Soekarno-Hatta International Airport",
                //   address: "Soekarno-Hatta International Airport, Tangerang City, Banten, Indonesia",
                //   country: "ID",
                //   isAirportZone: true,
                //   lat: -6.127119,
                //   lng: 106.6534595,
                // },
                // {
                //   name: "Gambir Station",
                //   address: "Gambir Station, Jalan Medan Merdeka Timur, Gambir, Central Jakarta City, Jakarta, Indonesia",
                //   country: "ID",
                //   isAirportZone: false,
                //   lat: -6.1767112,
                //   lng: 106.8306527,
                // },
                // {
                //   name: "Halim Perdana Kusuma",
                //   address: "Halim Perdana Kusuma, Jalan Medan Merdeka Timur, Gambir, Central Jakarta City, Jakarta, Indonesia",
                //   country: "ID",
                //   isAirportZone: true,
                //   lat: -6.265208800000002,
                //   lng: 106.8863459,
                // },
              ];

            case 30:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    // unsubscribe message
    this.$eventBus.$off("navigateToAirportTransfer");
    clearInterval(this.refreshSessionInterval);
    document.removeEventListener("keydown", this.handleEnter);
  },

  methods: {
    handleEnter: function handleEnter(e) {
      if (this.mode !== "airport-transfer") return;
      if (e.key !== "Enter") return;

      if (e.target.classList.contains("vs__search")) {
        return;
      }

      e.preventDefault();
      this.search();
    },
    swapLocation: function swapLocation() {
      var div = document.getElementById("airportTransfer");
      this.isDepartureFromAirport = !this.isDepartureFromAirport;

      // swap icon
      div.querySelector(".ic-switch").classList.toggle("onReverse");

      // swap location
      var tempLocation = this.searchRequest.pickUpLocation;
      this.searchRequest.pickUpLocation = this.searchRequest.dropOffLocation;
      this.searchRequest.dropOffLocation = tempLocation;

      // swap clone location
      var tempCloneLocation = this.searchClone.pickUpLocation;
      this.searchClone.pickUpLocation = this.searchClone.dropOffLocation;
      this.searchClone.dropOffLocation = tempCloneLocation;
    },
    bindModelFromModifySearch: function bindModelFromModifySearch(searchParameter, services, companies, modifySearch) {
      this.isModified = true;

      this.permissions = services;
      this.companyOption = companies;
      this.modifySearch = modifySearch;
      this.searchRequest = {
        pickUpLocation: {
          latitude: searchParameter.pickUpLocation.latitude,
          longitude: searchParameter.pickUpLocation.longitude,
          code: searchParameter.pickUpLocation.code,
          name: searchParameter.pickUpLocation.name,
          address: searchParameter.pickUpLocation.address,
          country: searchParameter.pickUpLocation.country,
          isAirportZone: searchParameter.pickUpLocation.isAirportZone
        },
        dropOffLocation: {
          latitude: searchParameter.dropOffLocation.latitude,
          longitude: searchParameter.dropOffLocation.longitude,
          code: searchParameter.dropOffLocation.code,
          name: searchParameter.dropOffLocation.name,
          address: searchParameter.dropOffLocation.address,
          country: searchParameter.dropOffLocation.country,
          isAirportZone: searchParameter.dropOffLocation.isAirportZone
        },
        pickUpDate: this.$helper.toDateString(searchParameter.pickUpDateTime, "YYYY-MM-DD"),
        pickUpTime: this.$helper.toDateString(searchParameter.pickUpDateTime, "HH:mm"),
        mode: searchParameter.mode,
        company: searchParameter.companyId
      };

      this.searchClone = {
        pickUpLocation: {
          latitude: searchParameter.pickUpLocation.latitude,
          longitude: searchParameter.pickUpLocation.longitude,
          code: searchParameter.pickUpLocation.code,
          name: searchParameter.pickUpLocation.name,
          address: searchParameter.pickUpLocation.address,
          country: searchParameter.pickUpLocation.country,
          isAirportZone: searchParameter.pickUpLocation.isAirportZone
        },
        dropOffLocation: {
          latitude: searchParameter.dropOffLocation.latitude,
          longitude: searchParameter.dropOffLocation.longitude,
          code: searchParameter.dropOffLocation.code,
          name: searchParameter.dropOffLocation.name,
          address: searchParameter.dropOffLocation.address,
          country: searchParameter.dropOffLocation.country,
          isAirportZone: searchParameter.dropOffLocation.isAirportZone
        }
      };

      // indicates whether departure using geolocation or google maps autocomplete
      this.isDepartureFromAirport = this.searchRequest.pickUpLocation.code !== undefined;
    },
    onKeyupAirportGeolocation: function onKeyupAirportGeolocation(target) {
      target.parentElement.querySelector(".geolocationAirport").classList.add("isOpen");
    },
    onClickAirportGeolocation: function onClickAirportGeolocation(airport, target) {
      switch (target) {
        case "pickup":
          this.searchRequest.pickUpLocation = {
            latitude: airport.lat,
            longitude: airport.long,
            code: airport.air_code,
            name: airport.air_name,
            address: airport.air_name,
            country: airport.cn_code
          };
          break;
        case "dropoff":
          this.searchRequest.dropOffLocation = {
            latitude: airport.lat,
            longitude: airport.long,
            code: airport.air_code,
            name: airport.air_name,
            address: airport.air_name,
            country: airport.cn_code
          };
          break;
      }
    },
    onClickPopularDestination: function onClickPopularDestination(popular, target) {
      switch (target) {
        case "pickup":
          this.searchRequest.pickUpLocation = {
            latitude: popular.lat,
            longitude: popular.lng,
            name: popular.name,
            address: popular.address,
            country: popular.country,
            isAirportZone: popular.isAirportZone
          };
          break;
        case "dropoff":
          this.searchRequest.dropOffLocation = {
            latitude: popular.lat,
            longitude: popular.lng,
            name: popular.name,
            address: popular.address,
            country: popular.country,
            isAirportZone: popular.isAirportZone
          };
          break;
      }
    },
    onFocusAutoComplete: function onFocusAutoComplete(target) {
      target.value = "";
    },
    onBlurAutoComplete: function onBlurAutoComplete(target) {
      switch (target.name) {
        case "airportPickUpLocation":
          target.value = this.searchRequest.pickUpLocation.name;
          var isEqualPickUpLocation = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEqual(this.searchRequest.pickUpLocation, this.searchClone.pickUpLocation);
          if (!isEqualPickUpLocation) {
            this.searchRequest.pickUpLocation.name = "";
          }
          break;
        case "airportDropOffLocation":
          target.value = this.searchRequest.dropOffLocation.name;
          var isEqualDropOffLocation = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEqual(this.searchRequest.dropOffLocation, this.searchClone.dropOffLocation);
          if (!isEqualDropOffLocation) {
            this.searchRequest.dropOffLocation.name = "";
          }
          break;
      }
    },
    onKeyupAutoComplete: function onKeyupAutoComplete(target) {
      var _this2 = this;

      document.querySelectorAll(".popularCity").forEach(function (element) {
        return element.classList.remove("isOpen");
      });

      var self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(function (_) {
        var autoCompleteResultElement = null;
        var options = {};
        var prefix = "";
        switch (target.name) {
          case "airportPickUpLocation":
            autoCompleteResultElement = document.getElementById("pickup-airportAutoCompleteResults");
            //options.country = self.searchRequest.dropOffLocation.country;
            if (self.isAvoidCrossCity) {
              var airport = _this2.airports.find(function (x) {
                return x.air_code === self.searchRequest.dropOffLocation.code;
              });
              if (airport) {
                prefix = airport.ct_name + ", ";
              }
            }
            break;
          case "airportDropOffLocation":
            autoCompleteResultElement = document.getElementById("dropoff-airportAutoCompleteResults");
            // options.country = self.searchRequest.pickUpLocation.country;
            if (self.isAvoidCrossCity) {
              var _airport = _this2.airports.find(function (x) {
                return x.air_code === self.searchRequest.pickUpLocation.code;
              });
              if (_airport) {
                prefix = _airport.ct_name + ", ";
              }
            }
            break;
        }
        // reset suggestion result
        autoCompleteResultElement.innerHTML = "";

        // handle empty pick-up location keyword
        if (target.value === "") {
          autoCompleteResultElement.parentElement.classList.remove("isOpen");
          return;
        }

        self.$parent.autocomplete.getPredictions("" + prefix + target.value, function (predictions) {
          // loop result
          predictions.forEach(function (prediction) {
            var item = document.createElement("li");
            item.innerHTML = self.$helper.getPlaceIcon(prediction.types, prediction.description) + "<div class='point-of-view'>" + prediction.structured_formatting.main_text + "</div>" + "<span>" + prediction.structured_formatting.secondary_text + "</span>";
            item.addEventListener("click", function (_) {
              return self.getPlace(target, prediction);
            });
            autoCompleteResultElement.appendChild(item);
          });
          // show the result
          autoCompleteResultElement.parentElement.classList.add("isOpen");
        }, options);
      }, 200);
    },
    getPlace: function getPlace(target, prediction) {
      var self = this;
      var result = null;
      self.$parent.autocomplete.getPlace(prediction, function (place) {
        var isAirportZone = prediction.types.includes("airport") || prediction.description.toLowerCase().includes("airport") ? true : false;

        switch (target.name) {
          case "airportPickUpLocation":
            result = document.getElementById("pickup-airportAutoCompleteResults");
            self.searchRequest.pickUpLocation = {
              latitude: place.latitude,
              longitude: place.longitude,
              name: place.name,
              address: place.address,
              country: place.country,
              isAirportZone: isAirportZone
            };
            self.searchClone.pickUpLocation = {
              latitude: place.latitude,
              longitude: place.longitude,
              name: place.name,
              address: place.address,
              country: place.country,
              isAirportZone: isAirportZone
            };
            self.handleDifferentCountry();
            break;
          case "airportDropOffLocation":
            result = document.getElementById("dropoff-airportAutoCompleteResults");
            self.searchRequest.dropOffLocation = {
              latitude: place.latitude,
              longitude: place.longitude,
              name: place.name,
              address: place.address,
              country: place.country,
              isAirportZone: isAirportZone
            };
            self.searchClone.dropOffLocation = {
              latitude: place.latitude,
              longitude: place.longitude,
              name: place.name,
              address: place.address,
              country: place.country,
              isAirportZone: isAirportZone
            };
            break;
        }
        // everytime user select the prediction, result list should be reset
        result.innerHTML = "";
      });
    },
    buildQueryParam: function buildQueryParam(request) {
      var queryParam = {};

      // pick-up
      queryParam.plt = request.pickUpLocation.latitude;
      queryParam.plg = request.pickUpLocation.longitude;
      queryParam.pcd = request.pickUpLocation.code;
      queryParam.pad = request.pickUpLocation.address;
      queryParam.pnm = request.pickUpLocation.name;
      queryParam.pcn = request.pickUpLocation.country ? request.pickUpLocation.country : request.dropOffLocation.country;
      queryParam.pia = request.pickUpLocation.isAirportZone;

      // drop-off
      queryParam.dlt = request.dropOffLocation.latitude;
      queryParam.dlg = request.dropOffLocation.longitude;
      queryParam.dcd = request.dropOffLocation.code;
      queryParam.dad = request.dropOffLocation.address;
      queryParam.dnm = request.dropOffLocation.name;
      queryParam.dcn = request.dropOffLocation.country ? request.dropOffLocation.country : request.pickUpLocation.country;
      queryParam.dia = request.dropOffLocation.isAirportZone;

      // start rent
      queryParam.ptm = request.pickUpDateTime.year + "." + request.pickUpDateTime.month + "." + request.pickUpDateTime.day + "-" + request.pickUpDateTime.hour + "." + request.pickUpDateTime.minute;

      // service type
      queryParam.svc = "airporttransfer";

      // HACK: handle duplication routing
      queryParam.ver = Math.random().toString(36).substr(2, 9);

      // search mode
      queryParam.mode = request.mode;

      // companyId
      queryParam.company = request.company;

      return queryParam;
    },
    search: function search() {
      this.isSubmitted = true;
      this.$v.searchRequest.$touch();
      if (this.$v.searchRequest.$error) {
        return;
      }
      // parse datetime
      if (this.searchRequest.pickUpDate && this.searchRequest.pickUpTime) {
        var pickUpDates = this.searchRequest.pickUpDate.split("-");
        var pickUpTimes = this.searchRequest.pickUpTime.split(":");
        this.searchRequest.pickUpDateTime = {
          year: parseInt(pickUpDates[0]),
          month: parseInt(pickUpDates[1]),
          day: parseInt(pickUpDates[2]),
          hour: parseInt(pickUpTimes[0]),
          minute: parseInt(pickUpTimes[1])
        };

        // this.searchRequest.mode = this.mode;
        this.searchRequest.mode = "Inquiry";

        if (this.searchRequest.mode === "Inquiry") {
          if (this.isModified) {
            this.$eventBus.$emit("executeModifySearch", this.buildQueryParam(this.searchRequest));
          } else {
            this.$router.push({
              path: "/availability/inquiry",
              query: this.buildQueryParam(this.searchRequest)
            });
          }
        } else {
          if (this.isModified) {
            this.$eventBus.$emit("executeModifySearch", this.buildQueryParam(this.searchRequest));
          } else {
            this.$router.push({
              path: "/availability/instant",
              query: this.buildQueryParam(this.searchRequest)
            });
          }
        }
      }
    },
    handleDifferentCountry: function handleDifferentCountry() {
      if (this.searchRequest.pickUpLocation.country != this.searchRequest.dropOffLocation.country) {
        this.searchRequest.dropOffLocation = {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0
        };

        var dropOffTextbox = document.getElementsByName("airportDropOffLocation")[0];

        if (dropOffTextbox) {
          dropOffTextbox.click();
          dropOffTextbox.focus();
        }
      }
    },
    validateButton: function validateButton() {
      return this.searchRequest.pickUpLocation.name && this.searchRequest.dropOffLocation.name;
    }
  }
});

/***/ }),

/***/ 590:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/airports';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ 591:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_userHelper_js__ = __webpack_require__(531);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: { type: String, required: true },
    companies: { type: Array },
    services: { type: Object }
  },
  data: function data() {
    return {
      isSubmitted: false,
      isModifySearch: false,
      pickUpHours: [],
      pickUpMinutes: [],
      dropOffHours: [],
      dropOffMinutes: [],
      minimumRentDate: null,
      maximumRentDate: null,
      refreshSessionInterval: null,
      durationValue: [],
      searchRequest: {
        pickUpLocation: {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
          isAirportZone: false
        },
        rentDate: null,
        rentTime: null,
        durationInHour: null,
        isSelfDrive: false,
        mode: "",
        company: null
      },
      permissions: null,
      companyOption: [],
      modifySearch: false
    };
  },
  validations: function validations() {
    return {
      searchRequest: {
        pickUpLocation: { name: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] } },
        rentDate: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
        rentTime: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] },
        durationInHour: { required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"] }
      }
    };
  },

  computed: {
    hasCompanySelector: function hasCompanySelector() {
      if (this.permissions) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_userHelper_js__["g" /* companySelectorHourly */])(this.permissions);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_3__helpers_userHelper_js__["g" /* companySelectorHourly */])(this.services);
    }
  },
  mounted: function mounted() {
    var toggler = document.getElementsByClassName("toggle-box")[0];
    var self = this;
    if (toggler) {
      document.getElementsByClassName("toggle-wrapper")[0].addEventListener("click", function (event) {
        self.searchRequest.isSelfDrive = !toggler.classList.toggle("active");
      });
    }
    document.addEventListener("click", function (event) {
      $.each($("#carSearch .list-autoComplete, #carSearch .popularCity"), function (index, value) {
        value.classList.remove("isOpen");
      });

      if ($("#carSearch .searchBox__input-from").is(event.target)) {
        var searchResult = $(event.target.parentElement).find(".list-autoComplete");
        var popularCity = $(event.target.parentElement).find(".popularCity");
        if (searchResult.length > 0 && searchResult[0].getElementsByTagName("li").length > 0) {
          searchResult[0].classList.add("isOpen");
        } else if (popularCity.length > 0 && popularCity[0].getElementsByTagName("li").length > 0) {
          popularCity[0].classList.add("isOpen");
        }
      }

      // toggle rentTime-box
      var rentTimeWrapper = document.querySelector("#rentTime-wrapper");
      if (rentTimeWrapper) {
        if (rentTimeWrapper.contains(event.target) && !event.target.parentElement.classList.contains("apply-renttime")) {
          document.querySelector(".rentTime-box").classList.remove("hidden");
        } else {
          document.querySelector(".rentTime-box").classList.add("hidden");
        }
      }
    });

    document.addEventListener("keydown", this.handleEnter);
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var publicSettings, profile, userType, minHourly, tempDurationList, i, minDays, maxMonths, self, defaultHour, defaultMinute, pickUpLocations;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch("setting/getAllPublic");

            case 2:
              publicSettings = _context.sent;
              _context.next = 5;
              return _this.$store.dispatch("user/getProfile");

            case 5:
              profile = _context.sent;
              userType = profile.userType;
              minHourly = publicSettings.find(function (val) {
                return val.key === "MinimumHourlyHire";
              });
              tempDurationList = [];

              for (i = minHourly.value; i <= 24; i++) {
                tempDurationList.push(Number(i));
              }
              _this.durationValue = tempDurationList;
              minDays = userType === "TenantUser" ? 0 : parseInt(_this.$helper.extractSetting(publicSettings, "SearchMinDay", 0));
              maxMonths = userType === "TenantUser" ? 10000 : parseInt(_this.$helper.extractSetting(publicSettings, "BookingLimit", 0));

              // const country = this.$helper.extractSetting(
              //   publicSettings,
              //   "CountryHours",
              //   0
              // );

              self = _this;
              // subscribe messages

              _this.$eventBus.$on("navigateToVehicleRental", function () {
                self.$parent.autocomplete.refreshToken();
              });
              _this.$eventBus.$on("bindVehicleRental", _this.bindModelFromModifySearch);

              _this.refreshSessionInterval = setInterval(function () {
                self.$parent.autocomplete.refreshToken();
              }, 60000);

              defaultHour = 10;
              defaultMinute = 0;


              _this.minimumRentDate = _this.$helper.toStringDate(_this.$helper.addDays(minDays));

              _this.maximumRentDate = _this.$helper.toStringDate(_this.$helper.addMonths(maxMonths));

              pickUpLocations = _this.$helper.extractSetting(publicSettings, "RentalPickup", "-6.2023616|106.8119382|National Monument|National Monument, Gambir, Central Jakarta City, Jakarta, Indonesia|ID").split("|");


              _this.searchRequest = {
                pickUpLocation: {
                  latitude: parseFloat(pickUpLocations[0]),
                  longitude: parseFloat(pickUpLocations[1]),
                  name: pickUpLocations[2],
                  address: pickUpLocations[3],
                  country: pickUpLocations[4],
                  isAirportZone: false
                },
                rentDate: _this.$helper.toStringDate(_this.$helper.addDays(minDays)),
                rentTime: defaultHour + ":0" + defaultMinute,
                durationInHour: Number(minHourly.value) || 1,
                isSelfDrive: false
              };

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    // unsubscribe message
    this.$eventBus.$off("navigateToVehicleRental");
    clearInterval(this.refreshSessionInterval);
    document.removeEventListener("keydown", this.handleEnter);
  },

  methods: {
    handleEnter: function handleEnter(e) {
      if (this.mode !== "rental") return;
      if (e.key !== "Enter") return;

      if (e.target.classList.contains("vs__search")) {
        return;
      }

      e.preventDefault();
      this.search();
    },
    bindModelFromModifySearch: function bindModelFromModifySearch(searchParameter, services, companies, modifySearch) {
      this.permissions = services;
      this.companyOption = companies;
      this.modifySearch = modifySearch;
      this.searchRequest = {
        pickUpLocation: {
          latitude: searchParameter.location.latitude,
          longitude: searchParameter.location.longitude,
          name: searchParameter.location.name,
          address: searchParameter.location.address,
          country: searchParameter.location.country
        },
        rentDate: this.$helper.toDateString(searchParameter.startRent, "YYYY-MM-DD"),
        rentTime: searchParameter.startRent.hour + ":" + searchParameter.startRent.minute,
        durationInHour: Number(searchParameter.durationInHour),
        isSelfDrive: searchParameter.isSelfDrive,
        mode: searchParameter.mode,
        company: searchParameter.companyId || null
      };

      this.isModifySearch = true;
    },
    onClickDurationPicker: function onClickDurationPicker(hours) {
      this.searchRequest.durationInHour = hours;
    },
    onFocusAutoComplete: function onFocusAutoComplete(target) {
      target.value = "";
    },
    onBlurAutoComplete: function onBlurAutoComplete(target) {
      target.value = this.searchRequest.pickUpLocation.name;
    },
    onKeyupAutoComplete: function onKeyupAutoComplete(target) {
      document.querySelectorAll(".popularCity").forEach(function (element) {
        return element.classList.remove("isOpen");
      });

      var self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(function (_) {
        var element = document.getElementById("autoComplete-rentalResults");

        // reset suggestion result
        element.innerHTML = "";

        // handle empty pick-up location keyword
        if (target.value === "") {
          element.parentElement.classList.remove("isOpen");
          return;
        }
        self.$parent.autocomplete.getPredictions(target.value, function (predictions) {
          // loop result
          predictions.forEach(function (prediction) {
            var item = document.createElement("li");
            item.innerHTML = self.$helper.getPlaceIcon(prediction.types, prediction.description) + "<div class='point-of-view'>" + prediction.structured_formatting.main_text + "</div><span>" + prediction.structured_formatting.secondary_text + "</span>";
            item.addEventListener("click", function (_) {
              return self.getPlace(prediction);
            });
            element.appendChild(item);
          });
          // show the result
          element.parentElement.classList.add("isOpen");
        });
      }, 200);
    },
    getPlace: function getPlace(prediction) {
      var self = this;
      self.$parent.autocomplete.getPlace(prediction, function (place) {
        var isAirportZone = prediction.types.includes("airport") || prediction.description.toLowerCase().includes("airport") ? true : false;
        self.searchRequest.pickUpLocation = {
          latitude: place.latitude,
          longitude: place.longitude,
          name: place.name,
          address: place.address,
          country: place.country,
          isAirportZone: isAirportZone
        };
        // everytime user select the prediction, result list should be reset
        document.getElementById("autoComplete-rentalResults").innerHTML = "";
      });
    },
    buildQueryParam: function buildQueryParam(request) {
      var queryParam = {};

      // pick-up location (coordinate & address)
      queryParam.plt = request.pickUpLocation.latitude;
      queryParam.plg = request.pickUpLocation.longitude;
      queryParam.pad = request.pickUpLocation.address;
      queryParam.pnm = request.pickUpLocation.name;
      queryParam.pcn = request.pickUpLocation.country;
      queryParam.pia = request.pickUpLocation.isAirportZone;

      // start rent
      queryParam.str = request.startRent.year + "." + request.startRent.month + "." + request.startRent.day + "-" + request.startRent.hour + "." + request.startRent.minute;

      // end rent
      // queryParam.enr = `${request.endRent.year}.${request.endRent.month}.${request.endRent.day}-${request.endRent.hour}.${request.endRent.minute}`;

      // with driver / self drive
      queryParam.slf = request.isSelfDrive;

      // service type
      queryParam.duration = request.durationInHour;

      // service type
      queryParam.svc = "rental";

      // HACK: handle duplication routing
      queryParam.ver = Math.random().toString(36).substr(2, 9);

      // search mode
      queryParam.mode = request.mode;

      // companyId
      queryParam.company = request.company;

      return queryParam;
    },
    search: function search() {
      this.isSubmitted = true;
      this.$v.searchRequest.$touch();
      if (this.$v.searchRequest.$error) {
        return;
      }
      // parse datetime
      if (this.searchRequest.rentDate && this.searchRequest.rentTime && this.searchRequest.durationInHour) {
        var startRentDates = this.searchRequest.rentDate.split("-");
        var startRentTimes = this.searchRequest.rentTime.split(":");
        this.searchRequest.startRent = {
          year: parseInt(startRentDates[0]),
          month: parseInt(startRentDates[1]),
          day: parseInt(startRentDates[2]),
          hour: parseInt(startRentTimes[0]),
          minute: parseInt(startRentTimes[1])
        };

        this.searchRequest.mode = "Inquiry";

        if (this.searchRequest.mode === "Inquiry") {
          if (this.isModifySearch) {
            this.$eventBus.$emit("executeModifySearchRental", this.buildQueryParam(this.searchRequest));
          } else {
            this.$router.push({
              path: "/availability/inquiry",
              query: this.buildQueryParam(this.searchRequest)
            });
          }
        } else {
          if (this.isModifySearch) {
            this.$eventBus.$emit("executeModifySearchRental", this.buildQueryParam(this.searchRequest));
          } else {
            this.$router.push({
              path: "/availability/instant",
              query: this.buildQueryParam(this.searchRequest)
            });
          }
        }
      }
    }
  }
});

/***/ }),

/***/ 596:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);



var _originalAvailabilities = null;
var _queryFilter = {};

function intersection(lists) {
  var result = [];
  for (var i = 0; i < lists.length; i++) {
    var currentList = lists[i];
    for (var y = 0; y < currentList.length; y++) {
      var currentValue = currentList[y];
      if (result.indexOf(currentValue) === -1) {
        if (lists.filter(function (obj) {
          return obj.indexOf(currentValue) == -1;
        }).length == 0) {
          result.push(currentValue);
        }
      }
    }
  }
  return result;
}

var AvailabilityFilter = function () {
  function AvailabilityFilter() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AvailabilityFilter);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AvailabilityFilter, [{
    key: "populate",
    value: function populate(items) {
      var result = {
        classes: [],
        specs: [],
        brands: [],
        sort: []
      };

      if (items && items.length > 0) {
        var _loop = function _loop(i) {
          var item = items[i];

          if (item.className) {
            var classType = result.classes.find(function (x) {
              return x.value === item.className.toLowerCase();
            });
            if (classType) {
              classType.count += 1;
            } else {
              result.classes.push({
                value: item.className.toLowerCase(),
                text: item.className,
                count: 1,
                isSelected: false,
                isEnable: true
              });
            }
          }

          if (item.feature) {
            if (item.feature.doors && item.feature.doors >= 4) {
              var doors = result.specs.find(function (x) {
                return x.value === "4doors";
              });
              if (doors) {
                doors.count += 1;
              } else {
                result.specs.push({
                  value: "4doors",
                  text: "4+ Doors",
                  count: 1,
                  isSelected: false,
                  isEnable: true
                });
              }
            }

            if (item.feature.hasAirConditioning) {
              var airConditioning = result.specs.find(function (x) {
                return x.value === "airConditioning";
              });
              if (airConditioning) {
                airConditioning.count += 1;
              } else {
                result.specs.push({
                  value: "airConditioning",
                  text: "With Air Conditioning",
                  count: 1,
                  isSelected: false,
                  isEnable: true
                });
              }
            }

            if (item.feature.largeBaggageCapacity) {
              var largeBaggage = result.specs.find(function (x) {
                return x.value === "largeBaggage";
              });
              if (largeBaggage) {
                largeBaggage.count += 1;
              } else {
                result.specs.push({
                  value: "largeBaggage",
                  text: "Large Baggage",
                  count: 1,
                  isSelected: false,
                  isEnable: true
                });
              }
            }

            if (item.feature.smallBaggageCapacity) {
              var smallBaggage = result.specs.find(function (x) {
                return x.value === "smallBaggage";
              });
              if (smallBaggage) {
                smallBaggage.count += 1;
              } else {
                result.specs.push({
                  value: "smallBaggage",
                  text: "Small Baggage",
                  count: 1,
                  isSelected: false,
                  isEnable: true
                });
              }
            }

            if (item.feature.transmission) {
              switch (item.feature.transmission.toLowerCase()) {
                case "at":
                  var automaticTransmission = result.specs.find(function (x) {
                    return x.value === "automaticTransmission";
                  });
                  if (automaticTransmission) {
                    automaticTransmission.count += 1;
                  } else {
                    result.specs.push({
                      value: "automaticTransmission",
                      text: "Automatic Transmission",
                      count: 1,
                      isSelected: false,
                      isEnable: true
                    });
                  }
                  break;
                case "mt":
                  var manualTransmission = result.specs.find(function (x) {
                    return x.value === "manualTransmission";
                  });
                  if (manualTransmission) {
                    manualTransmission.count += 1;
                  } else {
                    result.specs.push({
                      value: "manualTransmission",
                      text: "Manual Gearbox",
                      count: 1,
                      isSelected: false,
                      isEnable: true
                    });
                  }
                  break;
                case "autonomous":
                  var autonomousCar = result.specs.find(function (x) {
                    return x.value === "autonomousCar";
                  });
                  if (autonomousCar) {
                    autonomousCar.count += 1;
                  } else {
                    result.specs.push({
                      value: "autonomousCar",
                      text: "Autonomous Car",
                      count: 1,
                      isSelected: false,
                      isEnable: true
                    });
                  }
                  break;
              }
            }

            if (item.feature.paxCapacity && item.feature.paxCapacity >= 4) {
              var pax = result.specs.find(function (x) {
                return x.value === "4pax";
              });
              if (pax) {
                pax.count += 1;
              } else {
                result.specs.push({
                  value: "4pax",
                  text: "4+ Pax",
                  count: 1,
                  isSelected: false,
                  isEnable: true
                });
              }
            }
          }

          if (item.factoryName) {
            var factoryAndBrand = ((item.factoryName ? item.factoryName : '') + " " + (item.brandName ? item.brandName : '')).trim();
            if (factoryAndBrand) {
              var brand = result.brands.find(function (x) {
                return x.text === factoryAndBrand;
              });
              if (brand) {
                brand.count += 1;
              } else {
                result.brands.push({
                  value: factoryAndBrand.toLowerCase(),
                  text: factoryAndBrand,
                  count: 1,
                  isSelected: false,
                  isEnable: true
                });
              }
            }
          }
        };

        for (var i = 0; i < items.length; i++) {
          _loop(i);
        }

        result.sort = [{
          text: "Lowest Rate",
          value: "lowestRate"
        }, {
          text: "Highest Rate",
          value: "highestRate"
        }];

        _originalAvailabilities = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(items);
        _queryFilter['classes'] = [];
        _queryFilter['specs'] = [];
        _queryFilter['brands'] = [];
      }

      return result;
    }
  }, {
    key: "applyFilter",
    value: function applyFilter(query, filterType, sortType) {
      if (query.isSelected) {
        _queryFilter[filterType].push(query.value);
      } else {
        _queryFilter[filterType] = _queryFilter[filterType].filter(function (value) {
          return value !== query.value;
        });
      }

      var hasFilter = false;
      var unmergedIndex = -1;
      var unmergedResult = [];
      var tempUnmergedResult = [];

      var availabilities = JSON.parse(_originalAvailabilities);

      if (_queryFilter['classes'].length > 0) {
        hasFilter = true;
        unmergedIndex += 1;
        tempUnmergedResult = [];

        var _loop2 = function _loop2(i) {
          tempUnmergedResult = tempUnmergedResult.concat(availabilities.filter(function (x) {
            return x.className.toLowerCase() === _queryFilter['classes'][i];
          }));
        };

        for (var i = 0; i < _queryFilter['classes'].length; i++) {
          _loop2(i);
        }
        unmergedResult[unmergedIndex] = tempUnmergedResult;
      }

      if (_queryFilter['specs'].length > 0) {
        hasFilter = true;
        unmergedIndex += 1;
        tempUnmergedResult = [];
        for (var i = 0; i < _queryFilter['specs'].length; i++) {
          var _item = _queryFilter['specs'][i];
          switch (_item) {
            case '4doors':
              tempUnmergedResult = tempUnmergedResult.concat(availabilities.filter(function (x) {
                return x.feature.doors && x.feature.doors >= 4;
              }));
              break;
            case 'airConditioning':
              tempUnmergedResult = tempUnmergedResult.concat(availabilities.filter(function (x) {
                return x.feature.hasAirConditioning;
              }));
              break;
            case 'largeBaggage':
              tempUnmergedResult = tempUnmergedResult.concat(availabilities.filter(function (x) {
                return x.feature.largeBaggageCapacity && x.feature.largeBaggageCapacity > 0;
              }));
              break;
            case 'smallBaggage':
              tempUnmergedResult = tempUnmergedResult.concat(availabilities.filter(function (x) {
                return x.feature.smallBaggageCapacity && x.feature.smallBaggageCapacity > 0;
              }));
              break;
            case 'automaticTransmission':
              tempUnmergedResult = tempUnmergedResult.concat(availabilities.filter(function (x) {
                return x.feature.transmission && x.feature.transmission === 'AT';
              }));
              break;
            case 'manualTransmission':
              tempUnmergedResult = tempUnmergedResult.concat(availabilities.filter(function (x) {
                return x.feature.transmission && x.feature.transmission === 'MT';
              }));
              break;
            case 'autonomousCar':
              tempUnmergedResult = tempUnmergedResult.concat(availabilities.filter(function (x) {
                return x.feature.transmission && x.feature.transmission === 'Autonomous';
              }));
              break;
            case '4pax':
              tempUnmergedResult = tempUnmergedResult.concat(availabilities.filter(function (x) {
                return x.feature.paxCapacity && x.feature.paxCapacity >= 4;
              }));
              break;
          }
        }
        unmergedResult[unmergedIndex] = tempUnmergedResult;
      }

      if (_queryFilter['brands'].length > 0) {
        hasFilter = true;
        unmergedIndex += 1;
        tempUnmergedResult = [];

        var _loop3 = function _loop3(_i) {
          tempUnmergedResult = tempUnmergedResult.concat(availabilities.filter(function (x) {
            return ((x.factoryName ? x.factoryName : '') + " " + (x.brandName ? x.brandName : '')).trim().toLowerCase() === _queryFilter['brands'][_i];
          }));
        };

        for (var _i = 0; _i < _queryFilter['brands'].length; _i++) {
          _loop3(_i);
        }
        unmergedResult[unmergedIndex] = tempUnmergedResult;
      }

      // if no filter is selected, then set back the result to default
      if (!hasFilter) {
        return this.applySort(availabilities, sortType);
      }

      // intersect multiple array
      var result = intersection(unmergedResult);

      // apply sort
      return this.applySort(result, sortType);
    }
  }, {
    key: "applySort",
    value: function applySort(availabilities, sortType) {
      var result = [];
      switch (sortType) {
        case 'lowestRate':
          result = availabilities.sort(function (a, b) {
            var itemA = parseInt(a.totalFare);
            var itemB = parseInt(b.totalFare);
            if (itemA < itemB) return -1;
            if (itemA > itemB) return 1;
            return 0;
          });
          break;
        case 'highestRate':
          result = availabilities.sort(function (a, b) {
            var itemA = parseInt(a.totalFare);
            var itemB = parseInt(b.totalFare);
            if (itemA < itemB) return -1;
            if (itemA > itemB) return 1;
            return 0;
          }).reverse();
          break;
      }
      return result;
    }
  }, {
    key: "reset",
    value: function reset() {
      _queryFilter['classes'] = [];
      _queryFilter['specs'] = [];
      _queryFilter['brands'] = [];
      return JSON.parse(_originalAvailabilities);
    }
  }]);

  return AvailabilityFilter;
}();

/* harmony default export */ __webpack_exports__["a"] = (AvailabilityFilter);

/***/ }),

/***/ 604:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/shop/availabilities';

/* harmony default export */ __webpack_exports__["a"] = ({
  searchVehicleRental: function searchVehicleRental(request) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/rental', request).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  searchVehicleAirport: function searchVehicleAirport(request) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/airport', request).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  selectVehicle: function selectVehicle(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/vehicle', request).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  loadBookingForm: function loadBookingForm(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/form', request).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ 605:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transfer_vue__ = __webpack_require__(589);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_216ed9e3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transfer_vue__ = __webpack_require__(606);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transfer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_216ed9e3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transfer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 606:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.mode === 'airport-transfer' ? 'tab-pane in active' : 'tab-pane',attrs:{"id":"airportTransfer"}},[_c('div',{staticClass:"search__box"},[(_vm.modifySearch)?_c('button',{staticClass:"close-btn",on:{"click":function($event){return _vm.$emit('closeModal')}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M289.94 256l95-95A24 24 0 0 0 351 127l-95 95l-95-95a24 24 0 0 0-34 34l95 95l-95 95a24 24 0 1 0 34 34l95-95l95 95a24 24 0 0 0 34-34z","fill":"currentColor"}})])]):_vm._e(),_vm._v(" "),_c('form',{attrs:{"id":"searchTransportation"},on:{"submit":function($event){$event.preventDefault();return _vm.search($event)}}},[(_vm.hasCompanySelector)?[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"search__box-inputBox"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"wrapping__search-row"},[_c('div',{staticClass:"col-sm-12 search--boxPhase-1"},[_c('div',{staticClass:"wrap__input-box"},[_c('div',{staticClass:"col-sm-6"},[(_vm.isDepartureFromAirport)?_c('div',{staticClass:"pos-rel"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequest.pickUpLocation.name),expression:"searchRequest.pickUpLocation.name"}],staticClass:"searchBox__input searchBox__input-from",class:{
                          'field-error':
                            _vm.isSubmitted &&
                            _vm.$v.searchRequest.pickUpLocation.name.$error,
                        },attrs:{"type":"text","autocomplete":"off","tabindex":"1","name":"airportPickUpLocation"},domProps:{"value":(_vm.searchRequest.pickUpLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequest.pickUpLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(1)]):_vm._e(),_vm._v(" "),(!_vm.isDepartureFromAirport)?_c('div',{staticClass:"pos-rel"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequest.pickUpLocation.name),expression:"searchRequest.pickUpLocation.name"}],staticClass:"searchBox__input searchBox__input-from",class:{
                          'field-error':
                            _vm.isSubmitted &&
                            _vm.$v.searchRequest.pickUpLocation.name.$error,
                        },attrs:{"type":"text","autocomplete":"off","tabindex":"2","name":"airportPickUpLocation"},domProps:{"value":(_vm.searchRequest.pickUpLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequest.pickUpLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"switch-But",on:{"click":function($event){return _vm.swapLocation()}}},[_c('i',{staticClass:"ic-switch"})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[(_vm.isDepartureFromAirport)?_c('div',{staticClass:"pos-rel"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequest.dropOffLocation.name),expression:"searchRequest.dropOffLocation.name"}],staticClass:"searchBox__input searchBox__input-to",class:{
                          'field-error':
                            _vm.isSubmitted &&
                            _vm.$v.searchRequest.dropOffLocation.name.$error,
                        },attrs:{"type":"text","autocomplete":"off","tabindex":"2","name":"airportDropOffLocation"},domProps:{"value":(_vm.searchRequest.dropOffLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequest.dropOffLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(3)]):_vm._e(),_vm._v(" "),(!_vm.isDepartureFromAirport)?_c('div',{staticClass:"pos-rel"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequest.dropOffLocation.name),expression:"searchRequest.dropOffLocation.name"}],staticClass:"searchBox__input searchBox__input-to",class:{
                          'field-error':
                            _vm.isSubmitted &&
                            _vm.$v.searchRequest.dropOffLocation.name.$error,
                        },attrs:{"type":"text","autocomplete":"off","tabindex":"1","name":"airportDropOffLocation"},domProps:{"value":(_vm.searchRequest.dropOffLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequest.dropOffLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(4)]):_vm._e()])])])])])]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"search__box-inputBox"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"wrapping__search-row"},[_c('div',{staticClass:"col-sm-8 search--boxPhase-2"},[_c('div',{staticClass:"wrap__input-box"},[_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"ic-date-checkin pl-5"}),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"airportPickUpDate","min-date":_vm.minimumPickUpDate,"max-date":_vm.maximumPickUpDate,"color":"#025BC5","format":"YYYY-MM-DD","formatted":"MMM DD, YYYY","auto-close":"","only-date":"","no-label":"","no-header":"","no-button":"","no-button-now":""},model:{value:(_vm.searchRequest.pickUpDate),callback:function ($$v) {_vm.$set(_vm.searchRequest, "pickUpDate", $$v)},expression:"searchRequest.pickUpDate"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"ic-time"}),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"airportPickUpTime","color":"#025BC5","format":"HH:mm","formatted":"HH:mm","minute-interval":"5","overlay":"","only-time":"","no-label":"","no-header":"","no-button":""},model:{value:(_vm.searchRequest.pickUpTime),callback:function ($$v) {_vm.$set(_vm.searchRequest, "pickUpTime", $$v)},expression:"searchRequest.pickUpTime"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 search--boxPhase-3"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"padding":"0"}},[_c('v-select',{staticClass:"v-search-select airport-trr-select",attrs:{"id":"airport-trr-select","placeholder":"Select Company","label":"name","disabled":!_vm.hasCompanySelector,"options":_vm.companies || _vm.companyOption,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.id; }},model:{value:(_vm.searchRequest.company),callback:function ($$v) {_vm.$set(_vm.searchRequest, "company", $$v)},expression:"searchRequest.company"}})],1)])])])])]:[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"search__box-inputBox",attrs:{"id":"inline-search-inputBox"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"wrapping__search-row"},[_c('div',{staticClass:"col-sm-5 search--boxPhase-1"},[_c('div',{staticClass:"wrap__input-box"},[_c('div',{staticClass:"col-sm-6"},[(_vm.isDepartureFromAirport)?_c('div',{staticClass:"pos-rel"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequest.pickUpLocation.name),expression:"searchRequest.pickUpLocation.name"}],staticClass:"searchBox__input searchBox__input-from",class:{
                          'field-error':
                            _vm.isSubmitted &&
                            _vm.$v.searchRequest.pickUpLocation.name.$error,
                        },attrs:{"type":"text","autocomplete":"off","tabindex":"1","name":"airportPickUpLocation"},domProps:{"value":(_vm.searchRequest.pickUpLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequest.pickUpLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(7)]):_vm._e(),_vm._v(" "),(!_vm.isDepartureFromAirport)?_c('div',{staticClass:"pos-rel"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequest.pickUpLocation.name),expression:"searchRequest.pickUpLocation.name"}],staticClass:"searchBox__input searchBox__input-from",class:{
                          'field-error':
                            _vm.isSubmitted &&
                            _vm.$v.searchRequest.pickUpLocation.name.$error,
                        },attrs:{"type":"text","autocomplete":"off","tabindex":"2","name":"airportPickUpLocation"},domProps:{"value":(_vm.searchRequest.pickUpLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequest.pickUpLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(8)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"switch-But",on:{"click":function($event){return _vm.swapLocation()}}},[_c('i',{staticClass:"ic-switch"})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[(_vm.isDepartureFromAirport)?_c('div',{staticClass:"pos-rel"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequest.dropOffLocation.name),expression:"searchRequest.dropOffLocation.name"}],staticClass:"searchBox__input searchBox__input-to",class:{
                          'field-error':
                            _vm.isSubmitted &&
                            _vm.$v.searchRequest.dropOffLocation.name.$error,
                        },attrs:{"type":"text","autocomplete":"off","tabindex":"2","name":"airportDropOffLocation"},domProps:{"value":(_vm.searchRequest.dropOffLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequest.dropOffLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(9)]):_vm._e(),_vm._v(" "),(!_vm.isDepartureFromAirport)?_c('div',{staticClass:"pos-rel"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequest.dropOffLocation.name),expression:"searchRequest.dropOffLocation.name"}],staticClass:"searchBox__input searchBox__input-to",class:{
                          'field-error':
                            _vm.isSubmitted &&
                            _vm.$v.searchRequest.dropOffLocation.name.$error,
                        },attrs:{"type":"text","autocomplete":"off","tabindex":"1","name":"airportDropOffLocation"},domProps:{"value":(_vm.searchRequest.dropOffLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequest.dropOffLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(10)]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 search--boxPhase-2"},[_c('div',{staticClass:"wrap__input-box"},[_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"ic-date-checkin pl-5"}),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"airportPickUpDate","min-date":_vm.minimumPickUpDate,"max-date":_vm.maximumPickUpDate,"color":"#025BC5","format":"YYYY-MM-DD","formatted":"MMM DD","auto-close":"","only-date":"","no-label":"","no-header":"","no-button":"","no-button-now":""},model:{value:(_vm.searchRequest.pickUpDate),callback:function ($$v) {_vm.$set(_vm.searchRequest, "pickUpDate", $$v)},expression:"searchRequest.pickUpDate"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"ic-time"}),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"airportPickUpTime","color":"#025BC5","format":"HH:mm","formatted":"HH:mm","minute-interval":"5","overlay":"","only-time":"","no-label":"","no-header":"","no-button":""},model:{value:(_vm.searchRequest.pickUpTime),callback:function ($$v) {_vm.$set(_vm.searchRequest, "pickUpTime", $$v)},expression:"searchRequest.pickUpTime"}})],1)])])])])])],_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit","disabled":!_vm.validateButton()}},[_vm._v("\n        Find Transportation\n      ")])],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search__option-box"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('label',{staticClass:"depart-point"},[_vm._v("Address, Airport or Area")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6",staticStyle:{"padding-left":"35px"}},[_c('label',{staticClass:"drop-point"},[_vm._v("Address, Airport or Area")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete pickup-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"pickup-airportAutoCompleteResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete pickup-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"pickup-airportAutoCompleteResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete dropoff-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"dropoff-airportAutoCompleteResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete dropoff-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"dropoff-airportAutoCompleteResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search__option-box"},[_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('label',[_vm._v(" Pick-up Date ")]),_vm._v(" "),_c('span',{staticClass:"help-tip cursor-pointer",attrs:{"tabindex":"0","data-container":"body","data-toggle":"popover","data-placement":"top","data-content":"Local pick-up date."}},[_vm._v("\n                  ?\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('label',[_vm._v("Time")]),_vm._v(" "),_c('span',{staticClass:"help-tip cursor-pointer",attrs:{"tabindex":"0","data-container":"body","data-toggle":"popover","data-placement":"top","data-content":"Local pick-up time (please enter flight arrival time for airport pick-up)."}},[_vm._v("\n                  ?\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 pl-5"},[_c('label',[_vm._v(" Company ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search__option-box",attrs:{"id":"inline-search-optionBox"}},[_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('label',{staticClass:"depart-point"},[_vm._v("Address, Airport or Area")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 pl-25"},[_c('label',{staticClass:"drop-point"},[_vm._v("Address, Airport or Area")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 pl-5"},[_c('label',[_vm._v(" Pick-up Date ")]),_vm._v(" "),_c('span',{staticClass:"help-tip cursor-pointer",attrs:{"tabindex":"0","data-container":"body","data-toggle":"popover","data-placement":"top","data-content":"Local pick-up date."}},[_vm._v("\n                  ?\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('label',[_vm._v("Time")]),_vm._v(" "),_c('span',{staticClass:"help-tip cursor-pointer",attrs:{"tabindex":"0","data-container":"body","data-toggle":"popover","data-placement":"top","data-content":"Local pick-up time (please enter flight arrival time for airport pick-up)."}},[_vm._v("\n                  ?\n                ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete pickup-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"pickup-airportAutoCompleteResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete pickup-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"pickup-airportAutoCompleteResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete dropoff-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"dropoff-airportAutoCompleteResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete dropoff-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"dropoff-airportAutoCompleteResults"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 607:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rental_vue__ = __webpack_require__(591);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74f4497e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rental_vue__ = __webpack_require__(608);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rental_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74f4497e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rental_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 608:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.mode === 'rental' ? 'tab-pane in active' : 'tab-pane',attrs:{"id":"carSearch"}},[_c('div',{staticClass:"search__box"},[(_vm.modifySearch)?_c('button',{staticClass:"close-btn",on:{"click":function($event){return _vm.$emit('closeModal')}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M289.94 256l95-95A24 24 0 0 0 351 127l-95 95l-95-95a24 24 0 0 0-34 34l95 95l-95 95a24 24 0 1 0 34 34l95-95l95 95a24 24 0 0 0 34-34z","fill":"currentColor"}})])]):_vm._e(),_vm._v(" "),_c('form',{attrs:{"id":"searchRental"},on:{"submit":function($event){$event.preventDefault();return _vm.search($event)}}},[(_vm.hasCompanySelector)?[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"search__box-inputBox"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"wrapping__search-row"},[_c('div',{staticClass:"col-sm-6 search--boxPhase-1"},[_c('div',{staticClass:"wrap__input-box"},[_c('div',{staticClass:"col-sm-12 pl-5"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequest.pickUpLocation.name),expression:"searchRequest.pickUpLocation.name"}],staticClass:"searchBox__input searchBox__input-from",class:{
                        'field-error':
                          _vm.isSubmitted &&
                          _vm.$v.searchRequest.pickUpLocation.name.$error,
                      },attrs:{"type":"text","autocomplete":"off","tabindex":"1"},domProps:{"value":(_vm.searchRequest.pickUpLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequest.pickUpLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 search--boxPhase-3"},[_c('div',{staticClass:"wrap__input-box",attrs:{"id":"rentTime-wrapper"}},[_c('div',{staticClass:"col-sm-12"},[_c('i',{staticClass:"ic-time plz"}),_vm._v(" "),_c('span',{staticClass:"searchBox__input"},[_vm._v("\n                      "+_vm._s(_vm.searchRequest.durationInHour)+"\n                      "+_vm._s(_vm.searchRequest.durationInHour === 1 ? "Hour" : "Hours")+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"rentTime-box hidden"},[_c('div',[_c('div',{staticClass:"col-sm-12"},[_c('h5',[_vm._v("\n                            Duration\n                            "),_c('span',[_vm._v(_vm._s(_vm.searchRequest.durationInHour)+"\n                              "+_vm._s(_vm.searchRequest.durationInHour === 1
                                  ? "Hour"
                                  : "Hours"))])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"col-sm-12 plz list-time"},[_c('ul',{staticClass:"picktime-hour"},_vm._l((_vm.durationValue),function(item,index){return _c('li',{key:index},[_c('a',{class:{
                                      selected:
                                        item === _vm.searchRequest.durationInHour,
                                    },attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.onClickDurationPicker(item)}}},[_vm._v(_vm._s(item)+"\n                                    "+_vm._s(item === 1 ? "Hour" : "Hours"))])])}),0)])])])]),_vm._v(" "),_vm._m(3)])])])])])])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"search__box-inputBox"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"wrapping__search-row"},[_c('div',{staticClass:"col-sm-6 search--boxPhase-3"},[_c('div',{staticClass:"wrap__input-box"},[_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"ic-date-checkin pl-5"}),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"rentalRentDate","min-date":_vm.minimumRentDate,"max-date":_vm.maximumRentDate,"color":"#025BC5","format":"YYYY-MM-DD","formatted":"MMM DD, YYYY","auto-close":"","only-date":"","no-label":"","no-header":"","no-button":"","no-button-now":""},model:{value:(_vm.searchRequest.rentDate),callback:function ($$v) {_vm.$set(_vm.searchRequest, "rentDate", $$v)},expression:"searchRequest.rentDate"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"ic-time"}),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"airportPickUpTime","color":"#025BC5","format":"HH:mm","formatted":"HH:mm","minute-interval":"15","overlay":"","only-time":"","no-label":"","no-header":"","no-button":""},model:{value:(_vm.searchRequest.rentTime),callback:function ($$v) {_vm.$set(_vm.searchRequest, "rentTime", $$v)},expression:"searchRequest.rentTime"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 search--boxPhase-2"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"padding":"0"}},[_c('v-select',{staticClass:"v-search-select airport-trr-select",attrs:{"id":"airport-trr-select","placeholder":"Select Company","label":"name","disabled":!_vm.hasCompanySelector,"options":_vm.companies || _vm.companyOption,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.id; }},model:{value:(_vm.searchRequest.company),callback:function ($$v) {_vm.$set(_vm.searchRequest, "company", $$v)},expression:"searchRequest.company"}})],1)])])])])]:[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"search__box-inputBox"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"wrapping__search-row"},[_c('div',{staticClass:"col-sm-4 search--boxPhase-1"},[_c('div',{staticClass:"wrap__input-box"},[_c('div',{staticClass:"col-sm-12 pl-5"},[_c('i',{staticClass:"ic-marker-maps"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchRequest.pickUpLocation.name),expression:"searchRequest.pickUpLocation.name"}],staticClass:"searchBox__input searchBox__input-from",class:{
                        'field-error':
                          _vm.isSubmitted &&
                          _vm.$v.searchRequest.pickUpLocation.name.$error,
                      },attrs:{"type":"text","autocomplete":"off","tabindex":"1"},domProps:{"value":(_vm.searchRequest.pickUpLocation.name)},on:{"keyup":function($event){return _vm.onKeyupAutoComplete($event.target)},"focus":function($event){return _vm.onFocusAutoComplete($event.target)},"blur":function($event){return _vm.onBlurAutoComplete($event.target)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.searchRequest.pickUpLocation, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_vm._m(7)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 search--boxPhase-2"},[_c('div',{staticClass:"wrap__input-box"},[_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"ic-date-checkin pl-5"}),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"rentalRentDate","min-date":_vm.minimumRentDate,"max-date":_vm.maximumRentDate,"color":"#025BC5","format":"YYYY-MM-DD","formatted":"MMM DD","auto-close":"","only-date":"","no-label":"","no-header":"","no-button":"","no-button-now":""},model:{value:(_vm.searchRequest.rentDate),callback:function ($$v) {_vm.$set(_vm.searchRequest, "rentDate", $$v)},expression:"searchRequest.rentDate"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('i',{staticClass:"ic-time"}),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"airportPickUpTime","color":"#025BC5","format":"HH:mm","formatted":"HH:mm","minute-interval":"15","overlay":"","only-time":"","no-label":"","no-header":"","no-button":""},model:{value:(_vm.searchRequest.rentTime),callback:function ($$v) {_vm.$set(_vm.searchRequest, "rentTime", $$v)},expression:"searchRequest.rentTime"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 search--boxPhase-3"},[_c('div',{staticClass:"wrap__input-box",attrs:{"id":"rentTime-wrapper"}},[_c('div',{staticClass:"col-sm-12"},[_c('i',{staticClass:"ic-time plz"}),_vm._v(" "),_c('span',{staticClass:"searchBox__input"},[_vm._v("\n                      "+_vm._s(_vm.searchRequest.durationInHour)+"\n                      "+_vm._s(_vm.searchRequest.durationInHour === 1 ? "Hour" : "Hours")+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"rentTime-box hidden"},[_c('div',[_c('div',{staticClass:"col-sm-12"},[_c('h5',[_vm._v("\n                            Duration\n                            "),_c('span',[_vm._v(_vm._s(_vm.searchRequest.durationInHour)+"\n                              "+_vm._s(_vm.searchRequest.durationInHour === 1
                                  ? "Hour"
                                  : "Hours"))])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"col-sm-12 plz list-time"},[_c('ul',{staticClass:"picktime-hour"},_vm._l((_vm.durationValue),function(item,index){return _c('li',{key:index},[_c('a',{class:{
                                      selected:
                                        item === _vm.searchRequest.durationInHour,
                                    },attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.onClickDurationPicker(item)}}},[_vm._v(_vm._s(item)+"\n                                    "+_vm._s(item === 1 ? "Hour" : "Hours"))])])}),0)])])])]),_vm._v(" "),_vm._m(8)])])])])])])])],_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n        FIND TRANSPORTATION\n      ")])],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rental-search-label-box"},[_c('div',{staticClass:"search-location-label"},[_c('label',[_vm._v("Pickup Location")])]),_vm._v(" "),_c('div',{staticClass:"rental-company-label"},[_c('label',[_vm._v("Duration")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"autoComplete-rentalResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6 differ-box hidden"},[_c('i',{staticClass:"ic-marker-maps --grey50"}),_vm._v(" "),_c('div',{staticClass:"searchBox__input searchBox__input-to",attrs:{"tabindex":"2"}},[_vm._v("\n                      Surabaya\n                    ")]),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"arrival"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crowen cBet"},[_c('div',{staticClass:"list-time-footer cBet"},[_c('a',{staticClass:"--orange75 apply-renttime",staticStyle:{"margin-left":"auto"},attrs:{"href":"javascript:void(0)"}},[_c('strong',[_vm._v("Apply")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rental-search-label-box"},[_c('div',{staticClass:"rental-date-label"},[_c('label',[_vm._v("Pickup Date & Time")])]),_vm._v(" "),_c('div',{staticClass:"rental-time-label"},[_c('label',[_vm._v("Company")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rental-search-label-box",attrs:{"id":"search-rental-label-inline"}},[_c('div',{staticClass:"search-location-label"},[_c('label',[_vm._v("Pickup Location")])]),_vm._v(" "),_c('div',{staticClass:"rental-date-label"},[_c('label',[_vm._v("Pickup Date & Time")])]),_vm._v(" "),_c('div',{staticClass:"rental-time-label"},[_c('label',[_vm._v("Duration")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-autoComplete"},[_c('ul',{staticClass:"autoComplete-results",attrs:{"id":"autoComplete-rentalResults"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6 differ-box hidden"},[_c('i',{staticClass:"ic-marker-maps --grey50"}),_vm._v(" "),_c('div',{staticClass:"searchBox__input searchBox__input-to",attrs:{"tabindex":"2"}},[_vm._v("\n                      Surabaya\n                    ")]),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"arrival"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crowen cBet"},[_c('div',{staticClass:"list-time-footer cBet"},[_c('a',{staticClass:"--orange75 apply-renttime",staticStyle:{"margin-left":"auto"},attrs:{"href":"javascript:void(0)"}},[_c('strong',[_vm._v("Apply")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 624:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c446d14_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoTransportationAvailable_vue__ = __webpack_require__(626);
var normalizeComponent = __webpack_require__(56)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c446d14_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoTransportationAvailable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 626:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"null-vehicle-wrapper"},[_c('div',{staticClass:"img-no-traspontation"}),_vm._v(" "),_c('h3',{staticClass:"text-style"},[_vm._v("\n            Sorry, no options available :(\n          ")]),_vm._v(" "),_c('span',[_vm._v("This could be because your search location is not yet supported, or a minimum hourly booking period was not met.")]),_vm._v(" "),_c('p',[_vm._v("For assistance, please contact "),_c('a',{attrs:{"href":"mailto:support@trransfer.com","target":"_blank"}},[_vm._v("support@trransfer.com.")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 699:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_availability_result_inquiry_ResultTransfer__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_availability_result_inquiry_ResultRental__ = __webpack_require__(827);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    transfer: __WEBPACK_IMPORTED_MODULE_0__components_availability_result_inquiry_ResultTransfer__["a" /* default */],
    rental: __WEBPACK_IMPORTED_MODULE_1__components_availability_result_inquiry_ResultRental__["a" /* default */]
  },
  computed: {
    serviceType: function serviceType() {
      return this.$route.query.svc.toLowerCase();
    }
  },
  beforeDestroy: function beforeDestroy() {
    localStorage.removeItem("reservationRequest");
  }
});

/***/ }),

/***/ 700:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_NoTransportationAvailable__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_ConfirmModal__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_availability_form_Transfer__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_shop_availability_inquiryAvailabilityService_js__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_google_autocomplete_js__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_availabilityFilter_js__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_numberHelper_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__models_constants__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_master_company_companyService_js__ = __webpack_require__(505);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    confirmModal: __WEBPACK_IMPORTED_MODULE_4__components_shared_ConfirmModal__["a" /* default */],
    transferForm: __WEBPACK_IMPORTED_MODULE_5__components_availability_form_Transfer__["a" /* default */],
    NoTransportationAvailable: __WEBPACK_IMPORTED_MODULE_3__components_shared_NoTransportationAvailable__["a" /* default */]
  },
  data: function data() {
    return {
      autocomplete: null,
      correlationId: null,
      items: [],
      conversionRate: null,
      isLoading: false,
      pickUpDateTime: { offsetName: null },
      searchParameter: { mode: "" },
      transferDistance: null,
      isInquiry: true,
      filter: {
        classes: [],
        specs: [],
        brands: [],
        sort: [],
        defaultSort: null
      },
      filterHelper: null,
      refreshTimer: null,
      services: {},
      companies: []
    };
  },

  computed: {
    hasConversionRate: function hasConversionRate() {
      return this.conversionRate && this.conversionRate !== null;
    },

    pickUpLocation: function pickUpLocation() {
      return this.searchParameter.pickUpLocation.address ? this.searchParameter.pickUpLocation.address.split(",")[0] : "";
    },
    dropOffLocation: function dropOffLocation() {
      return this.searchParameter.dropOffLocation && this.searchParameter.dropOffLocation.address ? this.searchParameter.dropOffLocation.address.split(",")[0] : "Same Location";
    },
    shortStartRentDate: function shortStartRentDate() {
      return this.$helper.toDateString(this.searchParameter.pickUpDateTime, "D MMM");
    },
    shortEndRentDate: function shortEndRentDate() {
      return this.$helper.toDateString(this.searchParameter.pickUpDateTime, "D MMM");
    },
    shortStartRentTime: function shortStartRentTime() {
      return this.$helper.toDateString(this.searchParameter.pickUpDateTime, "h:mm A");
    },
    shortEndRentTime: function shortEndRentTime() {
      return this.$helper.toDateString(this.searchParameter.pickUpDateTime, "h:mm A");
    },
    longStartRentDate: function longStartRentDate() {
      return this.$helper.toDateString(this.searchParameter.pickUpDateTime, "ddd, D MMM yyyy");
    },
    longEndRentDate: function longEndRentDate() {
      return this.$helper.toDateString(this.searchParameter.pickUpDateTime, "ddd, D MMM yyyy");
    },
    countVehicle: function countVehicle() {
      return this.items.length;
    },
    cdn: function cdn() {
      return "https://maverick-global-assets-cp52hf.s3.ap-southeast-1.amazonaws.com";
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, services;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$helper.scrollTop();
              // subscribe message
              _this.$eventBus.$on("executeModifySearch", function (newQuery) {
                $("#modifySearch__modal").modal("hide");
                _this.getAvailabilities(newQuery);
                _this.$router.replace({ query: newQuery });
              });
              _context.next = 4;
              return _this.getAvailabilities(_this.$route.query);

            case 4:
              _context.next = 6;
              return _this.$store.dispatch("user/getProfile");

            case 6:
              _ref = _context.sent;
              services = _ref.services;

              _this.services = services;
              _this.getAllCompanies();

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("executeModifySearch");
    // unsubcribe partialview's eventbus
    this.$eventBus.$off("bindAirportTransfer");
  },
  mounted: function mounted() {
    // creates map instance
    this.autocomplete = new __WEBPACK_IMPORTED_MODULE_7__plugins_google_autocomplete_js__["a" /* default */]();
  },

  methods: {
    getAllCompanies: function getAllCompanies() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_11__services_master_company_companyService_js__["a" /* default */].getAllActive();

              case 2:
                _this2.companies = _context2.sent;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    checkSameCurrencyCode: function checkSameCurrencyCode(currencyCode) {
      var conversionRateCurrency = this.conversionRate && this.conversionRate.currency;
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual(conversionRateCurrency, currencyCode);
    },
    getLocalCurrency: function getLocalCurrency(originalCurrency) {
      return Object(__WEBPACK_IMPORTED_MODULE_9__helpers_numberHelper_js__["c" /* convertFromMarketFx */])(originalCurrency, this.conversionRate.conversionRate, this.conversionRate.conversionFormula);
    },
    onClickModifySearch: function onClickModifySearch() {
      // publish message
      this.$eventBus.$emit("bindAirportTransfer", this.searchParameter, this.services, this.companies, true);
      $("#modifySearch__modal").modal({ backdrop: "static", keyboard: false });
      $("#modifySearch__modal").css("overflow-y", "auto");
    },
    handleCloseModifySearch: function handleCloseModifySearch() {
      $("#modifySearch__modal").modal("hide");
    },
    initRefreshTimer: function initRefreshTimer() {
      if (this.refreshTimer) {
        clearTimeout(this.refreshTimer);
      }
      this.refreshTimer = setTimeout(function () {
        $("#modifySearch__modal").modal("hide");
        $("#confirmmodal").modal({ backdrop: "static", keyboard: false });
      }, this.$helper.fromMinutestoMilliseconds(29));
    },
    refresh: function refresh() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.getAvailabilities(_this3.$route.query);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getAvailabilities: function getAvailabilities(query) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response, filterResult, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this4.isLoading = true;
                // missing URL parameters

                if (!_this4.$helper.isEmpty(query)) {
                  _context4.next = 5;
                  break;
                }

                _this4.$helper.redirectToServerError(_this4);
                return _context4.abrupt("return");

              case 5:
                if (query.svc) {
                  _context4.next = 8;
                  break;
                }

                _this4.$helper.redirectToServerError(_this4);
                return _context4.abrupt("return");

              case 8:
                _this4.searchParameter = {
                  pickUpLocation: {
                    latitude: parseFloat(query.plt),
                    longitude: parseFloat(query.plg),
                    code: query.pcd,
                    name: query.pnm,
                    address: query.pad,
                    country: query.pcn,
                    isAirportZone: typeof query.pia === "boolean" ? query.pia : query.pia == "true"
                  },
                  dropOffLocation: {
                    latitude: parseFloat(query.dlt),
                    longitude: parseFloat(query.dlg),
                    code: query.dcd,
                    name: query.dnm,
                    address: query.dad,
                    country: query.dcn,
                    isAirportZone: typeof query.dia === "boolean" ? query.dia : query.dia == "true"
                  },
                  pickUpDateTime: _this4.$helper.toMaverickDateTime(query.ptm),
                  mode: query.mode,
                  companyId: query.company || null
                };

                // get availabilities from API
                _context4.next = 11;
                return __WEBPACK_IMPORTED_MODULE_6__services_shop_availability_inquiryAvailabilityService_js__["a" /* default */].searchVehicleAirport(_this4.searchParameter);

              case 11:
                response = _context4.sent;


                _this4.conversionRate = response.conversionRate;
                _this4.pickUpDateTime = response.pickUpDateTime;
                _this4.correlationId = response.correlationId;
                _this4.items = response.vehicles;
                _this4.transferDistance = response.stringDistance;

                _this4.filterHelper = new __WEBPACK_IMPORTED_MODULE_8__plugins_availabilityFilter_js__["a" /* default */]();
                filterResult = _this4.filterHelper.populate(_this4.items);

                _this4.filter.classes = filterResult.classes;
                _this4.filter.specs = filterResult.specs;
                _this4.filter.brands = filterResult.brands;
                _this4.filter.sort = filterResult.sort;
                _this4.filter.defaultSort = filterResult.sort[0].value;

                _this4.initRefreshTimer();
                _context4.next = 30;
                break;

              case 27:
                _context4.prev = 27;
                _context4.t0 = _context4["catch"](0);

                if (_context4.t0.errors) {
                  for (index = 0; index < _context4.t0.errors.length; index++) {
                    _this4.$notification.error(_context4.t0.errors[index], { title: "Error" });
                  }
                }

              case 30:
                _context4.prev = 30;

                _this4.isLoading = false;
                return _context4.finish(30);

              case 33:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 27, 30, 33]]);
      }))();
    },
    selectVehicle: function selectVehicle(vehicle) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var payload, response, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                payload = {
                  correlationId: _this5.correlationId,
                  serviceType: "airporttransfer",
                  selectorId: vehicle.selectorId
                };
                _context5.prev = 1;

                _this5.isLoading = true;
                _context5.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6__services_shop_availability_inquiryAvailabilityService_js__["a" /* default */].selectVehicle(payload);

              case 5:
                response = _context5.sent;

                _this5.$router.push({
                  name: "InquiryReservationForm",
                  params: { id: response }
                });
                _context5.next = 12;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](1);

                if (_context5.t0.errors) {
                  for (index = 0; index < _context5.t0.errors.length; index++) {
                    _this5.$notification.error(_context5.t0.errors[index], { title: "Error" });
                  }
                }

              case 12:
                _context5.prev = 12;

                _this5.isLoading = false;
                return _context5.finish(12);

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[1, 9, 12, 15]]);
      }))();
    },
    onChangeApplyFilter: function onChangeApplyFilter(item, selector) {
      this.items = this.filterHelper.applyFilter(item, selector, this.filter.defaultSort);
      var searchResultHeader = document.querySelector(".car-result-header");
      if (searchResultHeader) {
        this.$nextTick(function () {
          return searchResultHeader.scrollIntoView({ behavior: "smooth" });
        });
      }
    },
    onClickApplySort: function onClickApplySort(item) {
      return this.filterHelper.applySort(this.items, item.value);
    },
    onClickFilterReset: function onClickFilterReset() {
      this.items = this.filterHelper.reset();
      this.filter.defaultSort = this.filter.sort[0].value;
      for (var i = 0; i < this.filter.classes.length; i++) {
        this.filter.classes[i].isSelected = false;
        this.filter.classes[i].isEnable = true;
      }
      for (var _i = 0; _i < this.filter.specs.length; _i++) {
        this.filter.specs[_i].isSelected = false;
        this.filter.specs[_i].isEnable = true;
      }
      for (var _i2 = 0; _i2 < this.filter.brands.length; _i2++) {
        this.filter.brands[_i2].isSelected = false;
        this.filter.brands[_i2].isEnable = true;
      }
    }
  }
});

/***/ }),

/***/ 701:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_ConfirmModal__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_availability_form_Rental__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_NoTransportationAvailable__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_shop_availability_inquiryAvailabilityService_js__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_google_autocomplete_js__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_availabilityFilter_js__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_numberHelper_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__models_constants__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_master_company_companyService_js__ = __webpack_require__(505);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    confirmModal: __WEBPACK_IMPORTED_MODULE_4__components_shared_ConfirmModal__["a" /* default */],
    rentalForm: __WEBPACK_IMPORTED_MODULE_5__components_availability_form_Rental__["a" /* default */],
    NoTransportationAvailable: __WEBPACK_IMPORTED_MODULE_6__components_shared_NoTransportationAvailable__["a" /* default */]
  },
  data: function data() {
    return {
      offsetName: null,
      autocomplete: null,
      correlationId: null,
      items: [],
      isLoading: false,
      searchParameter: { mode: "" },
      moneyFormat: null,
      isInquiry: true,
      rentDays: null,
      filter: {
        classes: [],
        specs: [],
        brands: [],
        sort: [],
        defaultSort: null
      },
      showRangeDate: false,
      rentRangeDate: {
        startRent: {},
        endRent: {}
      },
      filterHelper: null,
      refreshTimer: null,
      conversionRate: null,
      services: {},
      companies: []
    };
  },

  computed: {
    hasConversionRate: function hasConversionRate() {
      return this.conversionRate && this.conversionRate !== null;
    },
    pickUpLocation: function pickUpLocation() {
      return this.searchParameter.location.address ? this.searchParameter.location.address.split(",")[0] : "";
    },
    shortStartRentDate: function shortStartRentDate() {
      return this.$helper.toDateString(this.rentRangeDate.startRent, "D MMM");
    },
    shortEndRentDate: function shortEndRentDate() {
      return this.$helper.toDateString(this.rentRangeDate.endRent, "D MMM");
    },
    shortStartRentTime: function shortStartRentTime() {
      return this.rentRangeDate.startRent && this.$helper.toDateString(this.rentRangeDate.startRent, "h:mm A");
    },
    shortEndRentTime: function shortEndRentTime() {
      return this.rentRangeDate.endRent && this.$helper.toDateString(this.rentRangeDate.endRent, "h:mm A");
    },
    longStartRentDate: function longStartRentDate() {
      return this.rentRangeDate.startRent && this.$helper.toDateString(this.rentRangeDate.startRent, "ddd, D MMM yyyy");
    },
    longEndRentDate: function longEndRentDate() {
      return this.rentRangeDate.endRent && this.$helper.toDateString(this.rentRangeDate.endRent, "ddd, D MMM yyyy");
    },
    countVehicle: function countVehicle() {
      return this.items.length;
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, services;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$helper.scrollTop();
              // subscribe message
              _this.$eventBus.$on("executeModifySearchRental", function (newQuery) {
                $("#modifySearch__modal").modal("hide");
                _this.getAvailabilities(newQuery);
                _this.$router.replace({ query: newQuery });
              });
              _context.next = 4;
              return _this.getAvailabilities(_this.$route.query);

            case 4:
              _context.next = 6;
              return _this.$store.dispatch("user/getProfile");

            case 6:
              _ref = _context.sent;
              services = _ref.services;

              _this.services = services;
              _this.getAllCompanies();

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("executeModifySearchRental");
    // unsubcribe partialview's eventbus
    this.$eventBus.$off("bindVehicleRental");
  },
  mounted: function mounted() {
    // creates map instance
    this.autocomplete = new __WEBPACK_IMPORTED_MODULE_8__plugins_google_autocomplete_js__["a" /* default */]();
  },

  methods: {
    getAllCompanies: function getAllCompanies() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_12__services_master_company_companyService_js__["a" /* default */].getAllActive();

              case 2:
                _this2.companies = _context2.sent;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getLocalCurrency: function getLocalCurrency(originalCurrency) {
      return Object(__WEBPACK_IMPORTED_MODULE_10__helpers_numberHelper_js__["c" /* convertFromMarketFx */])(originalCurrency, this.conversionRate.conversionRate, this.conversionRate.conversionFormula);
    },
    onClickModifySearch: function onClickModifySearch() {
      // publish message
      this.$eventBus.$emit("bindVehicleRental", this.searchParameter, this.services, this.companies, true);

      $("#modifySearch__modal").modal({ backdrop: "static", keyboard: false });
      $("#modifySearch__modal").css("overflow-y", "auto");
    },
    handleCloseModifySearch: function handleCloseModifySearch() {
      $("#modifySearch__modal").modal("hide");
    },
    initRefreshTimer: function initRefreshTimer() {
      if (this.refreshTimer) {
        clearTimeout(this.refreshTimer);
      }
      this.refreshTimer = setTimeout(function () {
        $("#modifySearch__modal").modal("hide");
        $("#confirmmodal").modal({ backdrop: "static", keyboard: false });
      }, this.$helper.fromMinutestoMilliseconds(29));
    },
    refresh: function refresh() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.getAvailabilities(_this3.$route.query);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getAvailabilities: function getAvailabilities(query) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response, filterResult, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this4.isLoading = true;
                _this4.showRangeDate = false;
                // missing URL parameters

                if (!_this4.$helper.isEmpty(query)) {
                  _context4.next = 6;
                  break;
                }

                _this4.$helper.redirectToServerError(_this4);
                return _context4.abrupt("return");

              case 6:
                if (query.svc) {
                  _context4.next = 9;
                  break;
                }

                _this4.$helper.redirectToServerError(_this4);
                return _context4.abrupt("return");

              case 9:
                _this4.searchParameter = {
                  location: {
                    latitude: parseFloat(query.plt),
                    longitude: parseFloat(query.plg),
                    name: query.pnm,
                    address: query.pad,
                    country: query.pcn,
                    isAirportZone: typeof query.pia === "boolean" ? query.pia : query.pia == "true"
                  },
                  startRent: _this4.$helper.toMaverickDateTime(query.str),
                  // endRent: this.$helper.toMaverickDateTime(query.enr),
                  isSelfDrive: query.slf && query.slf.toString().toLocaleLowerCase() === "true",
                  durationInHour: query.duration,
                  mode: query.mode,
                  companyId: query.company || null
                };
                // get availabilities from API
                _context4.next = 12;
                return __WEBPACK_IMPORTED_MODULE_7__services_shop_availability_inquiryAvailabilityService_js__["a" /* default */].searchVehicleRental(_this4.searchParameter);

              case 12:
                response = _context4.sent;


                _this4.conversionRate = response.conversionRate;
                _this4.correlationId = response.correlationId;
                _this4.items = response.vehicles;
                _this4.rentDays = response.rentDays;
                _this4.moneyFormat = response.moneyFormat;
                _this4.offsetName = response.startRent.offsetName;
                _this4.rentRangeDate = {
                  startRent: response.startRent,
                  endRent: response.endRent
                };
                _this4.showRangeDate = true;

                _this4.filterHelper = new __WEBPACK_IMPORTED_MODULE_9__plugins_availabilityFilter_js__["a" /* default */]();
                filterResult = _this4.filterHelper.populate(_this4.items);

                _this4.filter.classes = filterResult.classes;
                _this4.filter.specs = filterResult.specs;
                _this4.filter.brands = filterResult.brands;
                _this4.filter.sort = filterResult.sort;
                _this4.filter.defaultSort = filterResult.sort[0].value;

                _this4.initRefreshTimer();
                _context4.next = 34;
                break;

              case 31:
                _context4.prev = 31;
                _context4.t0 = _context4["catch"](0);

                if (_context4.t0.errors) {
                  for (index = 0; index < _context4.t0.errors.length; index++) {
                    _this4.$notification.error(_context4.t0.errors[index], { title: "Error" });
                  }
                }

              case 34:
                _context4.prev = 34;

                _this4.isLoading = false;
                return _context4.finish(34);

              case 37:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 31, 34, 37]]);
      }))();
    },
    selectVehicle: function selectVehicle(selectorId, selfDriveRateType) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                _this5.isLoading = true;
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_7__services_shop_availability_inquiryAvailabilityService_js__["a" /* default */].selectVehicle({
                  serviceType: "rental",
                  correlationId: _this5.correlationId,
                  selectorId: selectorId,
                  selfDriveRateType: 0
                  // selfDriveRateType: selfDriveRateType,
                });

              case 4:
                response = _context5.sent;

                _this5.$router.push({
                  name: "InquiryReservationFormRental",
                  params: { id: response }
                });
                _context5.next = 11;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](0);

                if (_context5.t0.errors) {
                  for (index = 0; index < _context5.t0.errors.length; index++) {
                    _this5.$notification.error(_context5.t0.errors[index], { title: "Error" });
                  }
                }

              case 11:
                _context5.prev = 11;

                _this5.isLoading = false;
                return _context5.finish(11);

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 8, 11, 14]]);
      }))();
    },
    printMoney: function printMoney(value) {
      return this.moneyFormat ? __WEBPACK_IMPORTED_MODULE_3_numeral___default()(value).format(this.moneyFormat.decimalFormat) : value;
    },
    getSelfDriveClass: function getSelfDriveClass(items, code) {
      return items.find(function (x) {
        return x.code === code;
      }) ? "ic-check" : "ic-close";
    },
    getSelfDriveRate: function getSelfDriveRate(items, grandTotal) {
      return items.reduce(function (a, b) {
        return a + b.rate;
      }, grandTotal);
    },
    onChangeApplyFilter: function onChangeApplyFilter(item, selector) {
      this.items = this.filterHelper.applyFilter(item, selector, this.filter.defaultSort);
    },
    onClickApplySort: function onClickApplySort(item) {
      return this.filterHelper.applySort(this.items, item.value);
    },
    onClickFilterReset: function onClickFilterReset() {
      this.items = this.filterHelper.reset();
      this.filter.defaultSort = this.filter.sort[0].value;
      for (var i = 0; i < this.filter.classes.length; i++) {
        this.filter.classes[i].isSelected = false;
        this.filter.classes[i].isEnable = true;
      }
      for (var _i = 0; _i < this.filter.specs.length; _i++) {
        this.filter.specs[_i].isSelected = false;
        this.filter.specs[_i].isEnable = true;
      }
      for (var _i2 = 0; _i2 < this.filter.brands.length; _i2++) {
        this.filter.brands[_i2].isSelected = false;
        this.filter.brands[_i2].isEnable = true;
      }
    }
  }
});

/***/ }),

/***/ 823:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultTransfer_vue__ = __webpack_require__(700);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b9a45b8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResultTransfer_vue__ = __webpack_require__(826);
function injectStyle (ssrContext) {
  __webpack_require__(824)
}
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b9a45b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultTransfer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b9a45b8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResultTransfer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 824:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(825);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(384)("5c1ce424", content, true, {});

/***/ }),

/***/ 825:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(383)(true);
// imports


// module
exports.push([module.i, ".li-info-availability[data-v-6b9a45b8]{list-style-type:\"*\";margin-left:8px;color:#888!important}.availability-link[data-v-6b9a45b8]{color:#2e86ab}", "", {"version":3,"sources":["/app/src/components/availability/result/inquiry/ResultTransfer.vue"],"names":[],"mappings":"AACA,uCACE,oBAAyB,AACzB,gBAAiB,AACjB,oBAAuB,CACxB,AACD,oCACE,aAAe,CAChB","file":"ResultTransfer.vue","sourcesContent":["\n.li-info-availability[data-v-6b9a45b8] {\n  list-style-type: \"\\002A\";\n  margin-left: 8px;\n  color: #888 !important;\n}\n.availability-link[data-v-6b9a45b8] {\n  color: #2e86ab;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 826:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"flight"},[_c('div',{staticClass:"jumbotron jumbo-sm"},[_c('div',{staticClass:"get-search"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"cBet"},[_c('div',{staticClass:"search__result-header"},[_c('div',{staticClass:"flight-route big-text"},[_c('div',[_vm._v("From "),_c('span',[_vm._v("•")]),_vm._v(" "+_vm._s(_vm.pickUpLocation))])]),_vm._v(" "),_c('div',{staticClass:"get-passenger-info"},[_c('div',[_vm._v("\n                  "+_vm._s(_vm.longStartRentDate)+" "),_c('span',[_vm._v("•")]),_vm._v("\n                  "+_vm._s(_vm.shortStartRentTime)+" "+_vm._s(_vm.pickUpDateTime.offsetName)+"\n                  "),(_vm.transferDistance)?_c('span',[_vm._v("•")]):_vm._e(),_vm._v("\n                  "+_vm._s(_vm.transferDistance)+"\n                ")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn--white mr-15",on:{"click":function($event){return _vm.onClickModifySearch()}}},[_vm._v("\n              Modify Search\n            ")])])])])])]),_vm._v(" "),_c('section',{staticClass:"car__search-result"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 prz"},[(_vm.isLoading)?_c('div',[_vm._m(0)]):_vm._e(),_vm._v(" "),(!_vm.isLoading && _vm.countVehicle)?_c('div',[_c('div',{staticClass:"filter-box--left"},[_c('div',{staticClass:"filter-box--header"},[_c('i',{staticClass:"ic-settings-horizontal"}),_vm._v(" Filter\n                "),_c('a',{staticClass:"reset-button",on:{"click":function($event){return _vm.onClickFilterReset()}}},[_vm._v("Reset")])]),_vm._v(" "),_c('div',{staticClass:"car-specification"},[(_vm.filter.classes && _vm.filter.classes.length > 0)?_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"group-filter"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"btn-group-checkbox"},_vm._l((_vm.filter.classes),function(item,index){return _c('label',{key:index,staticClass:"cursor-pointer d-block w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isSelected),expression:"item.isSelected"}],staticClass:"control-checkbox",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.isSelected)?_vm._i(item.isSelected,null)>-1:(item.isSelected)},on:{"change":[function($event){var $$a=item.isSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isSelected", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isSelected", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isSelected", $$c)}},function($event){return _vm.onChangeApplyFilter(item, 'classes')}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle text-filter"},[_vm._v("\n                          "+_vm._s(item.text)+"\n                        ")])])}),0)])]):_vm._e(),_vm._v(" "),(_vm.filter.specs && _vm.filter.specs.length > 0)?_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"group-filter"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"btn-group-checkbox"},_vm._l((_vm.filter.specs),function(item,index){return _c('label',{key:index,staticClass:"cursor-pointer d-block w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isSelected),expression:"item.isSelected"}],staticClass:"control-checkbox",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.isSelected)?_vm._i(item.isSelected,null)>-1:(item.isSelected)},on:{"change":[function($event){var $$a=item.isSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isSelected", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isSelected", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isSelected", $$c)}},function($event){return _vm.onChangeApplyFilter(item, 'specs')}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle text-filter"},[_vm._v("\n                          "+_vm._s(item.text)+"\n                        ")])])}),0)])]):_vm._e(),_vm._v(" "),(_vm.filter.brands && _vm.filter.brands.length > 0)?_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"group-filter"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"btn-group-checkbox"},_vm._l((_vm.filter.brands),function(item,index){return _c('label',{key:index,staticClass:"cursor-pointer d-block w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isSelected),expression:"item.isSelected"}],staticClass:"control-checkbox",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.isSelected)?_vm._i(item.isSelected,null)>-1:(item.isSelected)},on:{"change":[function($event){var $$a=item.isSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isSelected", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isSelected", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isSelected", $$c)}},function($event){return _vm.onChangeApplyFilter(item, 'brands')}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle text-filter"},[_vm._v("\n                          "+_vm._s(item.text)+"\n                        ")])])}),0)])]):_vm._e()])]),_vm._v(" "),(_vm.filter.sort && _vm.filter.sort.length > 0)?_c('div',{staticClass:"filter-box--left hidden"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"btn-group-radio"},_vm._l((_vm.filter.sort),function(item,index){return _c('label',{key:index,staticClass:"wrap-radio"},[_c('span',[_vm._v(_vm._s(item.text))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter.defaultSort),expression:"filter.defaultSort"}],attrs:{"type":"radio","name":"sortPrice"},domProps:{"value":item.value,"checked":_vm.filter.defaultSort === item.value,"checked":_vm._q(_vm.filter.defaultSort,item.value)},on:{"click":function($event){return _vm.onClickApplySort(item)},"change":function($event){return _vm.$set(_vm.filter, "defaultSort", item.value)}}}),_vm._v(" "),_c('span',{staticClass:"bullet-mark"})])}),0)])]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('div',{staticClass:"car-result-header"},[(!_vm.isLoading && _vm.countVehicle)?_c('div',{staticClass:"row cRow"},[_c('div',{staticClass:"col-sm-6"},[(_vm.isLoading)?_c('strong',{staticStyle:{"color":"#fff"}}):_c('div',{staticClass:"flex-column"},[_c('strong',{staticClass:"--blue25"},[_vm._v("\n                    "+_vm._s(_vm.countVehicle)+" Transportation(s) available\n                  ")])])]),_vm._v(" "),(_vm.filter.sort && _vm.filter.sort.length > 0)?_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"row cRow"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-sm-9 text-center pz"},[_c('div',{staticClass:"form-group mbz"},[_c('div',{staticClass:"btn-group-radio"},_vm._l((_vm.filter.sort),function(item,index){return _c('label',{key:index,staticClass:"wrap-radio"},[_c('span',[_vm._v(_vm._s(item.text))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter.defaultSort),expression:"filter.defaultSort"}],attrs:{"type":"radio","name":"sortPrice"},domProps:{"value":item.value,"checked":_vm.filter.defaultSort === item.value,"checked":_vm._q(_vm.filter.defaultSort,item.value)},on:{"click":function($event){return _vm.onClickApplySort(item)},"change":function($event){return _vm.$set(_vm.filter, "defaultSort", item.value)}}}),_vm._v(" "),_c('span',{staticClass:"bullet-mark"})])}),0)])])])]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.isLoading && _vm.countVehicle)?_c('div',{staticClass:"row cRow"},[_vm._m(6)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"car-result"},[(_vm.isLoading)?_c('ul',{staticClass:"c-list"},_vm._l((4),function(index){return _c('div',{key:index,staticClass:"loader-list"},[_vm._m(7,true),_vm._v(" "),_vm._m(8,true)])}),0):_vm._e(),_vm._v(" "),(!_vm.isLoading && _vm.countVehicle)?_c('ul',{staticClass:"c-list"},_vm._l((_vm.items),function(item,index){return _c('li',{key:index},[_c('div',{staticClass:"wrap__select-list"},[_c('div',{staticClass:"header-box cars"},[_c('div',{staticClass:"col-sm-8 pz cRow"},[_c('div',{staticClass:"col-sm-4 pz"},[_c('img',{staticClass:"cars-image",attrs:{"src":item.imageUri,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 pl-20"},[_c('div',{staticClass:"cars-brand"},[_vm._v(_vm._s(item.className))]),_vm._v(" "),(
                            item.factoryName !== null ||
                            item.brandName !== null
                          )?_c('div',{staticClass:"model-car"},[_c('span',[_vm._v(_vm._s(item.factoryName)+" "+_vm._s(item.brandName))])]):_vm._e(),_vm._v(" "),(item.feature && item.feature.paxCapacity > 0)?_c('div',{staticClass:"capacity-seat"},[_vm._v("\n                          Max. Passenger "+_vm._s(item.feature.paxCapacity)+"\n                        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 prz"},[_c('div',{staticClass:"cars__info-3 text-right"},[_c('div',[_c('div',{staticClass:"price-value flex-column",staticStyle:{"line-height":"18px"}},[_c('span',[_vm._v(_vm._s(item.currencyCode)+"\n                              "+_vm._s(_vm.$currencyFormat(
                                  item.currencyCode,
                                  item.totalFare
                                ))+"\n                            ")]),_vm._v(" "),(
                                _vm.hasConversionRate &&
                                !_vm.checkSameCurrencyCode(item.currencyCode)
                              )?_c('span',{staticClass:"local-currency --grey45"},[_vm._v(_vm._s(_vm.conversionRate.currency)+"\n                              "+_vm._s(_vm.$currencyFormat(
                                  _vm.conversionRate.currency,
                                  _vm.getLocalCurrency(item.totalFare)
                                ))+"\n                            ")]):_vm._e()]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary",attrs:{"type":"submit"},on:{"click":function($event){return _vm.selectVehicle(item)}}},[_vm._v("\n                            Select\n                          ")])])])])]),_vm._v(" "),(item.rateTaggings.length > 0)?_c('div',{staticClass:"row mb-20"},[_c('div',{staticClass:"col-sm-3"}),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},_vm._l((item.rateTaggings),function(val,index){return _c('span',{key:index,staticClass:"badge badge-tagging",style:(("color: " + (val.textColor) + " !important; background: " + (val.backgroundColor) + " !important"))},[_vm._v(_vm._s(val.text))])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"provider-box hidden"},[_c('div',{staticClass:"col-sm-9 plz"}),_vm._v(" "),_c('div',{staticClass:"col-sm-3 prz text-right"},[_c('a',{staticClass:"btn btn-primary",attrs:{"type":"submit"},on:{"click":function($event){return _vm.selectVehicle(item)}}},[_vm._v("\n                        Select\n                      ")])])])])])}),0):_vm._e()]),_vm._v(" "),(!_vm.isLoading && _vm.countVehicle)?_c('div',{staticClass:"includes-info",staticStyle:{"font-size":"0.8rem"}},[_vm._m(9)]):_vm._e()])]),_vm._v(" "),(!_vm.isLoading && !_vm.countVehicle)?_c('div',{staticClass:"row"},[_c('NoTransportationAvailable')],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"modal fade modal-dark",attrs:{"role":"dialog","id":"modifySearch__modal"}},[_c('div',{staticClass:"modal-dialog modal-lg main__search"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('transferForm',{attrs:{"mode":_vm.searchParameter.mode},on:{"closeModal":function($event){return _vm.handleCloseModifySearch()}}})],1)])])]),_vm._v(" "),_c('confirmModal',{attrs:{"header":'Still looking for a car?',"content":'We recommend refreshing your results to see up-to-date prices for your search.',"submit-label":'Refresh'},on:{"submit":_vm.refresh}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-box--left"},[_c('div',{staticClass:"filter-box--header"},[_c('div',{staticClass:"loader-list--lines shine big-title pull-left"}),_vm._v(" "),_c('div',{staticClass:"loader-list--circle shine big-title pull-right"})]),_vm._v(" "),_c('div',{staticClass:"car-specification mb-20"},[_c('div',{staticClass:"loader-list--lines shine big-title"}),_vm._v(" "),_c('div',{staticClass:"loader-list--lines shine --small"}),_vm._v(" "),_c('div',{staticClass:"loader-list--lines shine --small"}),_vm._v(" "),_c('div',{staticClass:"loader-list--lines shine --small"}),_vm._v(" "),_c('div',{staticClass:"loader-list--lines shine --small"}),_vm._v(" "),_c('div',{staticClass:"loader-list--lines shine --small"})]),_vm._v(" "),_c('div',{staticClass:"car-specification mb-20"},[_c('div',{staticClass:"loader-list--lines shine big-title"}),_vm._v(" "),_c('div',{staticClass:"loader-list--lines shine --small"}),_vm._v(" "),_c('div',{staticClass:"loader-list--lines shine --small"}),_vm._v(" "),_c('div',{staticClass:"loader-list--lines shine --small"}),_vm._v(" "),_c('div',{staticClass:"loader-list--lines shine --small"})]),_vm._v(" "),_c('div',{staticClass:"car-specification mb-20"},[_c('div',{staticClass:"loader-list--lines shine big-title"}),_vm._v(" "),_c('div',{staticClass:"loader-list--lines shine --small"}),_vm._v(" "),_c('div',{staticClass:"loader-list--lines shine --small"}),_vm._v(" "),_c('div',{staticClass:"loader-list--lines shine --small"}),_vm._v(" "),_c('div',{staticClass:"loader-list--lines shine --small"})]),_vm._v(" "),_c('div',{staticClass:"car-specification mb-20"},[_c('div',{staticClass:"loader-list--lines shine big-title"}),_vm._v(" "),_c('div',{staticClass:"loader-list--lines shine --small"}),_vm._v(" "),_c('div',{staticClass:"loader-list--lines shine --small"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('button',{staticClass:"btn btn-block"},[_vm._v("\n                        Class "),_c('i',{staticClass:"ic-chevron-up"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('button',{staticClass:"btn btn-block"},[_vm._v("\n                        Car Specification "),_c('i',{staticClass:"ic-chevron-up"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('button',{staticClass:"btn btn-block"},[_vm._v("\n                        Brand "),_c('i',{staticClass:"ic-chevron-up"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-box--header"},[_c('i',{staticClass:"ic-filter"}),_vm._v(" Sort\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3 prz"},[_c('div',{staticClass:"filter-box--header pull-right pz"},[_c('i',{staticClass:"ic-filter hidden"}),_vm._v("Sort by:\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12"},[_c('ul',[_c('li',{staticClass:"li-info-availability"},[_c('span',{staticClass:"text-12 --grey45"},[_vm._v("All Includes Fuel, Toll and Parking")])]),_vm._v(" "),_c('li',{staticClass:"li-info-availability"},[_c('span',{staticClass:"text-12 --grey45"},[_vm._v("Rates are not applicable to major events, festivals and\n                      concerts. Please contact\n                      "),_c('a',{staticClass:"availability-link",attrs:{"target":"_blank","href":"mailto:support@trranster.com"}},[_vm._v("support@trranster.com")]),_vm._v("\n                      for special event quotes.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"loader-list--image shine"})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 plz"},[_c('div',{staticClass:"loader-list--lines shine big-title"}),_vm._v(" "),_c('div',{staticClass:"loader-list--lines shine"}),_vm._v(" "),_c('div',{staticClass:"loader-list--lines shine"}),_vm._v(" "),_c('div',{staticClass:"loader-list--lines shine"})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"loader-list--lines shine big-title pull-right"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row hidden"},[_c('div',{staticClass:"col-sm-1"},[_c('div',{staticClass:"loader-list--circle shine"})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"loader-list--lines shine"}),_vm._v(" "),_c('div',{staticClass:"loader-list--lines shine"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticStyle:{"list-style-type":"none"}},[_c('li',[_vm._v("Quote includes:")]),_vm._v(" "),_c('li',{staticClass:"img-watch"},[_vm._v("\n                60 minutes complimentary wait time (international arrivals)\n                for airport pick-ups, 15 mins for all others\n              ")]),_vm._v(" "),_c('li',{staticClass:"img-meet"},[_vm._v("\n                Airport Meet & Greet (available as an extra service for\n                minibus and coach)\n              ")]),_vm._v(" "),_c('li',{staticClass:"img-time"},[_vm._v("\n                Free cancellation up until 24 hours before pick-up time\n              ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 827:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultRental_vue__ = __webpack_require__(701);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cb2de4c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResultRental_vue__ = __webpack_require__(830);
function injectStyle (ssrContext) {
  __webpack_require__(828)
}
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6cb2de4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultRental_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cb2de4c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResultRental_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 828:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(829);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(384)("aa9a6c18", content, true, {});

/***/ }),

/***/ 829:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(383)(true);
// imports


// module
exports.push([module.i, "ul.title-tncs[data-v-6cb2de4c]{color:#212121;font-size:16px;font-weight:600}ul.item-tncs[data-v-6cb2de4c]{color:#777;font-size:15px;font-weight:400!important}", "", {"version":3,"sources":["/app/src/components/availability/result/inquiry/ResultRental.vue"],"names":[],"mappings":"AACA,+BACE,cAAe,AACf,eAAgB,AAChB,eAAiB,CAClB,AACD,8BACE,WAAe,AACf,eAAgB,AAChB,yBAA4B,CAC7B","file":"ResultRental.vue","sourcesContent":["\nul.title-tncs[data-v-6cb2de4c] {\n  color: #212121;\n  font-size: 16px;\n  font-weight: 600;\n}\nul.item-tncs[data-v-6cb2de4c] {\n  color: #777777;\n  font-size: 15px;\n  font-weight: 400 !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 830:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"flight"},[_c('div',{staticClass:"jumbotron jumbo-sm"},[_c('div',{staticClass:"get-search"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"cBet"},[_c('div',{staticClass:"search__result-header"},[_c('div',{staticClass:"flight-route big-text",staticStyle:{"text-transform":"capitalize"}},[_c('div',[_vm._v("\n                  Hourly Booking"),_c('span',[_vm._v("•")]),_vm._v("\n                  "+_vm._s(_vm.searchParameter.isSelfDrive ? "Self Drive" : "Chauffeur")+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"get-passenger-info"},[_c('div',[_vm._v("\n                  "+_vm._s(_vm.pickUpLocation)+" "),_c('span',[_vm._v("•")]),_vm._v(" "),(_vm.showRangeDate)?[_vm._v(_vm._s(_vm.longStartRentDate + " " + _vm.shortStartRentTime)+" -\n                    "+_vm._s(_vm.longEndRentDate + " " + _vm.shortEndRentTime))]:_vm._e(),_vm._v(" "),(_vm.offsetName)?[_c('span',[_vm._v("•")]),_vm._v(" "+_vm._s(_vm.offsetName))]:_vm._e()],2)])]),_vm._v(" "),_c('button',{staticClass:"btn btn--white mr-15",on:{"click":function($event){return _vm.onClickModifySearch()}}},[_vm._v("\n              Modify Search\n            ")])])])])])]),_vm._v(" "),_c('section',{staticClass:"car__search-result"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 prz"},[(!_vm.isLoading && _vm.countVehicle)?_c('div',[_c('div',{staticClass:"filter-box--left"},[_c('div',{staticClass:"filter-box--header"},[_c('i',{staticClass:"ic-settings-horizontal"}),_vm._v(" Filter\n                "),_c('a',{staticClass:"reset-button",on:{"click":function($event){return _vm.onClickFilterReset()}}},[_vm._v("Reset")])]),_vm._v(" "),_c('div',{staticClass:"car-specification"},[(_vm.filter.classes && _vm.filter.classes.length > 0)?_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"group-filter"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"btn-group-checkbox"},_vm._l((_vm.filter.classes),function(item,index){return _c('div',{key:index,staticClass:"checkbox"},[_c('label',{staticClass:"w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isSelected),expression:"item.isSelected"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.isSelected)?_vm._i(item.isSelected,null)>-1:(item.isSelected)},on:{"change":[function($event){var $$a=item.isSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isSelected", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isSelected", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isSelected", $$c)}},function($event){return _vm.onChangeApplyFilter(item, 'classes')}]}}),_vm._v(_vm._s(item.text)+"\n                        ")])])}),0)])]):_vm._e(),_vm._v(" "),(_vm.filter.specs && _vm.filter.specs.length > 0)?_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"group-filter"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"btn-group-checkbox"},_vm._l((_vm.filter.specs),function(item,index){return _c('div',{key:index,staticClass:"checkbox"},[_c('label',{staticClass:"w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isSelected),expression:"item.isSelected"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.isSelected)?_vm._i(item.isSelected,null)>-1:(item.isSelected)},on:{"change":[function($event){var $$a=item.isSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isSelected", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isSelected", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isSelected", $$c)}},function($event){return _vm.onChangeApplyFilter(item, 'specs')}]}}),_vm._v(_vm._s(item.text)+"\n                        ")])])}),0)])]):_vm._e(),_vm._v(" "),(_vm.filter.brands && _vm.filter.brands.length > 0)?_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"group-filter"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"btn-group-checkbox"},_vm._l((_vm.filter.brands),function(item,index){return _c('div',{key:index,staticClass:"checkbox"},[_c('label',{staticClass:"w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isSelected),expression:"item.isSelected"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(item.isSelected)?_vm._i(item.isSelected,null)>-1:(item.isSelected)},on:{"change":[function($event){var $$a=item.isSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isSelected", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isSelected", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isSelected", $$c)}},function($event){return _vm.onChangeApplyFilter(item, 'brands')}]}}),_vm._v(_vm._s(item.text)+"\n                        ")])])}),0)])]):_vm._e()])]),_vm._v(" "),(_vm.filter.sort && _vm.filter.sort.length > 0)?_c('div',{staticClass:"filter-box--left"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"btn-group-radio"},_vm._l((_vm.filter.sort),function(item,index){return _c('label',{key:index,staticClass:"wrap-radio"},[_c('span',[_vm._v(_vm._s(item.text))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter.defaultSort),expression:"filter.defaultSort"}],attrs:{"type":"radio","name":"sortPrice"},domProps:{"value":item.value,"checked":_vm.filter.defaultSort === item.value,"checked":_vm._q(_vm.filter.defaultSort,item.value)},on:{"click":function($event){return _vm.onClickApplySort(item)},"change":function($event){return _vm.$set(_vm.filter, "defaultSort", item.value)}}}),_vm._v(" "),_c('span',{staticClass:"bullet-mark"})])}),0)])]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[(!_vm.isLoading && _vm.countVehicle)?_c('div',{staticClass:"car-result-header"},[_c('div',{staticClass:"row cRow"},[_c('div',{staticClass:"col-sm-3"},[_c('strong',{staticClass:"--blue25"},[_vm._v("\n                  "+_vm._s(_vm.countVehicle)+" car type(s) available\n                ")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"car-result"},[(_vm.isLoading)?_c('ul',{staticClass:"c-list"},_vm._l((4),function(index){return _c('div',{key:index,staticClass:"loader-list"},[_vm._m(4,true),_vm._v(" "),_vm._m(5,true)])}),0):_vm._e(),_vm._v(" "),(!_vm.isLoading && _vm.searchParameter.isSelfDrive)?_c('ul',{staticClass:"c-list"},_vm._l((_vm.items),function(item,index){return _c('li',{key:index,staticClass:"choose-rate"},[_c('div',{staticClass:"wrap__select-list"},[_c('div',{staticClass:"header-box cars"},[_c('div',{staticClass:"col-sm-12 pz"},[_c('div',{staticClass:"col-sm-3 pz"},[_c('div',{staticClass:"cars-brand"},[_vm._v(_vm._s(item.className))]),_vm._v(" "),(
                            item.factoryName !== null ||
                            item.brandName !== null
                          )?_c('div',{staticClass:"model-car"},[_c('span',[_vm._v(_vm._s(item.factoryName)+" "+_vm._s(item.brandName))])]):_vm._e(),_vm._v(" "),_c('img',{staticClass:"cars-image",attrs:{"src":item.imageUri,"alt":""}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-toggle":"modal","data-target":"#terms-modal"}},[_vm._v("\n                          Rental Terms\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 pl-25 divider-left prz"},[_c('div',{staticClass:"max-capacity"},[(
                              item.feature && item.feature.paxCapacity > 0
                            )?_c('div',{staticClass:"capacity-seat"},[_vm._v("\n                            Pax "+_vm._s(item.feature.paxCapacity)+"\n                          ")]):_vm._e(),_vm._v(" "),(
                              item.feature &&
                              item.feature.largeBaggageCapacity > 0
                            )?_c('div',{staticClass:"capacity-large-baggage"},[_vm._v("\n                            Large Bag. x"+_vm._s(item.feature.largeBaggageCapacity)+"\n                          ")]):_vm._e(),_vm._v(" "),(
                              item.feature &&
                              item.feature.smallBaggageCapacity > 0
                            )?_c('div',{staticClass:"capacity-baggage"},[_vm._v("\n                            Small Bag. x"+_vm._s(item.feature.smallBaggageCapacity)+"\n                          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"table-responsive table-cars-rate"},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-right bz"}),_vm._v(" "),_vm._m(6,true),_vm._v(" "),_vm._m(7,true),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("\n                                  Select Rate"),_c('span',{staticClass:"--green35"},[_c('strong',[_vm._v("("+_vm._s(item.currencyCode)+")")])])])])]),_vm._v(" "),_c('tbody',_vm._l((item.selfDriveRates),function(rate){return _c('tr',{key:rate.type},[_c('td',{staticClass:"bz"},[_vm._v("Rate "+_vm._s(rate.type))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('i',{class:_vm.getSelfDriveClass(rate.items, 'LDW')})]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('i',{class:_vm.getSelfDriveClass(rate.items, 'PAI')})]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                                  "+_vm._s(_vm.printMoney(
                                      _vm.getSelfDriveRate(
                                        rate.items,
                                        item.totalFare
                                      )
                                    ))+"\n                                  "),_c('span',[_c('a',{staticClass:"btn btn-primary",attrs:{"type":"submit"},on:{"click":function($event){return _vm.selectVehicle(item.classId, true)}}},[_vm._v("\n                                      Select Car\n                                    ")])])])])}),0)])])])])])])])}),0):_vm._e(),_vm._v(" "),(!_vm.isLoading && !_vm.searchParameter.isSelfDrive)?_c('ul',{staticClass:"c-list"},_vm._l((_vm.items),function(item,index){return _c('li',{key:index},[_c('div',{staticClass:"wrap__select-list"},[_c('div',{staticClass:"header-box cars"},[_c('div',{staticClass:"col-sm-8 pz"},[_c('div',{staticClass:"col-sm-3 pz"},[_c('img',{staticClass:"cars-image",attrs:{"src":item.imageUri,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 pl-30"},[_c('div',{staticClass:"cars-brand"},[_vm._v(_vm._s(item.className))]),_vm._v(" "),(
                            item.factoryName !== null ||
                            item.brandName !== null
                          )?_c('div',{staticClass:"model-car"},[_c('span',[_vm._v(_vm._s(item.factoryName)+" "+_vm._s(item.brandName))])]):_vm._e(),_vm._v(" "),(item.feature && item.feature.paxCapacity > 0)?_c('div',{staticClass:"capacity-seat"},[_vm._v("\n                          Pax "+_vm._s(item.feature.paxCapacity)+"\n                        ")]):_vm._e(),_vm._v(" "),(
                            item.feature &&
                            item.feature.largeBaggageCapacity > 0
                          )?_c('div',{staticClass:"capacity-large-baggage"},[_vm._v("\n                          Large Bag. x"+_vm._s(item.feature.largeBaggageCapacity)+"\n                        ")]):_vm._e(),_vm._v(" "),(
                            item.feature &&
                            item.feature.smallBaggageCapacity > 0
                          )?_c('div',{staticClass:"capacity-baggage"},[_vm._v("\n                          Small Bag. x"+_vm._s(item.feature.smallBaggageCapacity)+"\n                        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"cars__info-3 text-right"},[_c('div',[_c('div',{staticClass:"price-value flex-column"},[_c('span',[_vm._v("\n                              "+_vm._s(item.currencyCode)+"\n                              "+_vm._s(_vm.$currencyFormat(
                                  item.currencyCode,
                                  item.totalFare
                                ))+"\n                            ")]),_vm._v(" "),(_vm.hasConversionRate)?_c('span',{staticClass:"text-10 --grey45"},[_vm._v("\n                              "+_vm._s(_vm.conversionRate.currency)+"\n                              "+_vm._s(_vm.$currencyFormat(
                                  _vm.conversionRate.currency,
                                  _vm.getLocalCurrency(item.totalFare)
                                ))+"\n                            ")]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"provider-box"},[_c('div',{staticClass:"col-sm-9 plz"},_vm._l((item.rateTaggings),function(val,index){return _c('span',{key:index,staticClass:"badge badge-tagging",style:(("color: " + (val.textColor) + " !important; background: " + (val.backgroundColor) + " !important"))},[_vm._v(_vm._s(val.text))])}),0),_vm._v(" "),_c('div',{staticClass:"col-sm-3 prz text-right"},[(!_vm.searchParameter.isSelfDrive)?_c('a',{staticClass:"btn btn-primary",attrs:{"type":"submit"},on:{"click":function($event){return _vm.selectVehicle(item.selectorId, false)}}},[_vm._v("\n                        Select Car\n                      ")]):_vm._e()])])])])}),0):_vm._e()]),_vm._v(" "),(!_vm.isLoading && _vm.countVehicle)?_c('div',{staticClass:"includes-info-rental",staticStyle:{"font-size":"0.8rem"}},[_vm._m(8),_vm._v(" "),_vm._m(9)]):_vm._e()])]),_vm._v(" "),(!_vm.isLoading && !_vm.countVehicle)?_c('div',{staticClass:"row"},[_c('NoTransportationAvailable')],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"modal fade modal-dark",attrs:{"role":"dialog","id":"modifySearch__modal"}},[_c('div',{staticClass:"modal-dialog modal-lg main__search"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('rentalForm',{attrs:{"mode":_vm.searchParameter.mode},on:{"closeModal":function($event){return _vm.handleCloseModifySearch()}}})],1)])])]),_vm._v(" "),_c('confirmModal',{attrs:{"header":'Still looking for a car?',"content":'We recommend refreshing your results to see up-to-date prices for your search.',"submit-label":'Refresh'},on:{"submit":_vm.refresh}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('button',{staticClass:"btn btn-block"},[_vm._v("\n                        Class "),_c('i',{staticClass:"ic-chevron-up"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('button',{staticClass:"btn btn-block"},[_vm._v("\n                        Car Specification "),_c('i',{staticClass:"ic-chevron-up"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('button',{staticClass:"btn btn-block"},[_vm._v("\n                        Brand "),_c('i',{staticClass:"ic-chevron-up"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-box--header"},[_c('i',{staticClass:"ic-filter"}),_vm._v(" Sort\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"loader-list--image shine"})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 plz"},[_c('div',{staticClass:"loader-list--lines shine big-title"}),_vm._v(" "),_c('div',{staticClass:"loader-list--lines shine"}),_vm._v(" "),_c('div',{staticClass:"loader-list--lines shine"}),_vm._v(" "),_c('div',{staticClass:"loader-list--lines shine"})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"loader-list--lines shine big-title pull-right"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-1"},[_c('div',{staticClass:"loader-list--circle shine"})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"loader-list--lines shine"}),_vm._v(" "),_c('div',{staticClass:"loader-list--lines shine"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"text-center"},[_vm._v("\n                                  LDW "),_c('span',[_vm._v("Loss Damage Waiver")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"text-center"},[_vm._v("\n                                  PAI "),_c('span',[_vm._v("Personal Accident Insurance")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"title-tncs",staticStyle:{"list-style-type":"none"}},[_c('li',[_vm._v("Terms and Conditions:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"item-tncs",staticStyle:{"padding":"0 15px"}},[_c('li',[_vm._v("\n                Quote does not include tolls and parking, which will be\n                charged as incurred post-service.\n              ")]),_vm._v(" "),_c('li',[_vm._v("\n                Additional surcharges may apply for airport pick-up and\n                drop-off, and garage-to-garage travel time.\n              ")]),_vm._v(" "),_c('li',[_vm._v("\n                Extended usage on the day of service will be subject to driver\n                availability. Additional hours will be billed post-service.\n              ")]),_vm._v(" "),_c('li',[_vm._v("Unused hours booked will not be refunded or credited.")]),_vm._v(" "),_c('li',[_vm._v("\n                Free cancellation up until 24 hours before pick-up time.\n              ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 831:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.serviceType === 'airporttransfer')?_c('transfer'):(_vm.serviceType === 'rental')?_c('rental'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/13.74f062eced59b377af05.js